import React, { useState, useEffect, useRef, useCallback } from 'react';
import { 
  Layout, 
  Card, 
  Table, 
  Tag, 
  Button, 
  Space, 
  Input, 
  Row, 
  Col, 
  Statistic, 
  Badge,
  Tooltip,
  Modal,
  message,
  Spin,
  Empty,
  Typography,
  Descriptions,
  Alert,
  Select,
  Divider,
  Tabs,
  DatePicker,
  Pagination
} from 'antd';
import { Resizable } from 'react-resizable';
import 'react-resizable/css/styles.css';
import { 
  CheckCircleOutlined, 
  CloseCircleOutlined,
  EyeOutlined,
  ClockCircleOutlined,
  FileTextOutlined,
  ReloadOutlined,
  SearchOutlined,
  ExclamationCircleOutlined,
  UserOutlined,
  CalendarOutlined,
  RobotOutlined,
  DatabaseOutlined,
  FormOutlined,
  FileImageOutlined,
  VideoCameraOutlined,
  AudioOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileExcelOutlined,
  FilePptOutlined,
  FileZipOutlined,
  FileOutlined,
  DownloadOutlined,
  SaveOutlined,
  CloseOutlined,
  ClearOutlined,
  LeftOutlined,
  RightOutlined,
  PlusOutlined,
  MinusOutlined
} from '@ant-design/icons';
import { useLanguage } from '../contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { TimezoneUtils } from '../utils/timezoneUtils';
import { getCurrentUsername } from '../utils/userUtils';
import { buildFormPreviewBlobUrl, collectFilledHtmlFromIframe } from '../utils/formPreviewIframeUtils';
import { getEFormApprovalLabels } from '../utils/eformApprovalLabels';
import { canExportEformToPdf, exportSingleEformInstanceToPdf } from '../utils/eformPdfExportUtils';
import Cleave from 'cleave.js';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { validateEFormRequiredFields } from '../utils/eformValidation';
import { getFlatpickrDateFormat, parseDisplayToIso, isIsoDateString, dateToLocalIsoString, injectFlatpickrIntoIframe } from '../utils/eformDateUtils';
import { EFormContentViewer } from '../components/MetaFlowResponseView';
import EFormViewerBody from '../components/EFormViewerBody';
import DefinitionCategoryTabs from '../components/DefinitionCategoryTabs/DefinitionCategoryTabs';
import * as XLSX from 'xlsx';

/** ?萄謘?閰剁????鞊?????????date ??data-input-type="date"??*/
const FORM_INPUT_SELECTOR = 'input[type="text"], input[type="tel"], input[type="email"], input[type="number"], input[type="date"], input[type="month"], input[type="time"], input[data-input-type="currency"], input[data-input-type="date"]';

const { Header, Content } = Layout;
const { Search } = Input;
const { Option } = Select;
const { Title, Text } = Typography;
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;

const PENDING_TASKS_FILTER_STORAGE_KEY = 'pendingTasksFilters';

const getDefaultPendingTasksFilters = () => ({
  searchText: '',
  definition: 'all',
  dateRange: [dayjs().subtract(7, 'day').startOf('day'), dayjs().endOf('day')]
});

const toPendingTasksDayjsRange = (arr) => {
  if (!Array.isArray(arr) || arr.length !== 2) return null;
  const a = arr[0] && dayjs(arr[0]).isValid() ? dayjs(arr[0]) : null;
  const b = arr[1] && dayjs(arr[1]).isValid() ? dayjs(arr[1]) : null;
  if (!a || !b) return null;
  // 若儲存的結束日期早於今日結束，自動推進至今日，確保當天新資料不被截斷
  const todayEnd = dayjs().endOf('day');
  return [a, b.isBefore(todayEnd) ? todayEnd : b];
};

function getInitialPendingTasksFilters() {
  try {
    const raw = localStorage.getItem(PENDING_TASKS_FILTER_STORAGE_KEY);
    if (!raw) return getDefaultPendingTasksFilters();
    const data = JSON.parse(raw);
    const definition = data.definition;
    return {
      searchText: typeof data.searchText === 'string' ? data.searchText : '',
      definition: definition != null && definition !== '' ? definition : 'all',
      dateRange: toPendingTasksDayjsRange(data.dateRange) || getDefaultPendingTasksFilters().dateRange
    };
  } catch (_) {
    return getDefaultPendingTasksFilters();
  }
}

function persistPendingTasksFilters(filters) {
  try {
    const toIsoRange = (range) => {
      if (!range || !Array.isArray(range) || range.length !== 2) return null;
      const a = range[0] && (range[0].toISOString ? range[0].toISOString() : dayjs(range[0]).toISOString());
      const b = range[1] && (range[1].toISOString ? range[1].toISOString() : dayjs(range[1]).toISOString());
      return a && b ? [a, b] : null;
    };
    localStorage.setItem(PENDING_TASKS_FILTER_STORAGE_KEY, JSON.stringify({
      searchText: filters.searchText || '',
      definition: filters.definition ?? 'all',
      dateRange: toIsoRange(filters.dateRange)
    }));
  } catch (_) {}
}

// ????Ｘ??瞏剛???
const customTableStyle = `
  .custom-table-with-summary .ant-table-thead > tr > th {
    padding: 8px 12px !important;
    height: 40px !important;
    line-height: 1.2 !important;
  }
  
  .custom-table-with-summary .ant-table-tbody > tr > td {
    padding: 8px 12px !important;
    vertical-align: top !important;
  }
  
  .custom-table-with-summary .ant-table-tbody > tr {
    height: auto !important;
    min-height: 40px !important;
  }
  
  .custom-table-with-summary .ant-table-tbody > tr:hover {
    background-color: #f5f5f5 !important;
  }
  
  .form-summary-field {
    display: inline-flex;
    align-items: center;
    background-color: #f0f8ff;
    padding: 2px 6px;
    border-radius: 4px;
    border: 1px solid #d6e4ff;
    margin-right: 4px;
    margin-bottom: 2px;
  }
  
  .form-summary-field-label {
    font-size: 11px;
    color: #666;
    margin-right: 4px;
  }
  
  .form-summary-field-value {
    font-size: 11px;
    font-weight: 500;
    color: #1890ff;
  }
`;

// ResizableTitle 組件
const ResizableTitle = (props) => {
  const { onResize, width, ...restProps } = props;
  if (!width) return <th {...restProps} />;
  return (
    <Resizable
      width={width}
      height={0}
      minConstraints={[30, 0]}
      handle={
        <span
          style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: '8px', cursor: 'col-resize', zIndex: 1, userSelect: 'none' }}
          onClick={e => e.stopPropagation()}
        />
      }
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <th {...restProps} style={{ position: 'relative' }} />
    </Resizable>
  );
};

/**
 * ??JSON ?鞊??改???HTML ?萄赯? */
const convertJsonToHtmlTable = (data) => {
  if (!data || typeof data !== 'object') {
    return '';
  }

  let html = '<table style="width: 100%; border-collapse: collapse; font-size: 13px;">';
  
  // ?????? processed ?鞊?????謚????
  let processedData = null;
  if (data.processed && typeof data.processed === 'object') {
    processedData = data.processed;
  } else if (data.raw && typeof data.raw === 'string') {
// ?謅疵??? raw ?殉??暸??? JSON ?殉?瘜菟?????迎?????????
try {
      let rawParsed = JSON.parse(data.raw);
// ??? rawParsed ?蟡??????∪????????
if (typeof rawParsed === 'string') {
        rawParsed = JSON.parse(rawParsed);
      }
      if (rawParsed.processed && typeof rawParsed.processed === 'object') {
        processedData = rawParsed.processed;
      } else if (rawParsed && typeof rawParsed === 'object' && !rawParsed.raw) {
// ??? rawParsed ?蟡???謢 processed ?鞊??????raw ?殉??曉??
processedData = rawParsed;
      }
    } catch (e) {
      // handle parse error
    }
  }

// ?????processed ?鞊????????
if (processedData) {
// ?輯???items ?鞎??蝞??
if (processedData.items && Array.isArray(processedData.items) && processedData.items.length > 0) {
      html += '<thead><tr style="background-color: #f5f5f5; border-bottom: 2px solid #d9d9d9;">';
      html += '<th style="padding: 8px 12px; text-align: left; font-weight: 600;">??梱????</th>';
      html += '<th style="padding: 8px 12px; text-align: right; font-weight: 600;">?撖僱</th>';
      html += '</tr></thead>';
      html += '<tbody>';
      
      processedData.items.forEach((item, index) => {
        const bgColor = index % 2 === 0 ? '#ffffff' : '#fafafa';
        html += `<tr style="background-color: ${bgColor}; border-bottom: 1px solid #f0f0f0;">`;
        html += `<td style="padding: 8px 12px;">${item.name || '-'}</td>`;
        html += `<td style="padding: 8px 12px; text-align: right; font-weight: 500;">${item.price || 0}</td>`;
        html += '</tr>';
      });
      
      html += '</tbody>';
      
      // ?輯??扯鞈?
      if (processedData.total !== undefined) {
        html += '<tfoot><tr style="background-color: #f0f8ff; border-top: 2px solid #1890ff; font-weight: 600;">';
        html += '<td style="padding: 10px 12px; text-align: right;">?株釭?</td>';
        html += `<td style="padding: 10px 12px; text-align: right; color: #1890ff;">${processedData.total}</td>`;
        html += '</tr></tfoot>';
      }
      
// ?輯??扳豯?????謚???
if (processedData.type) {
        html += '<tfoot><tr style="background-color: #fafafa;">';
        html += '<td colspan="2" style="padding: 8px 12px; text-align: center; color: #666; font-style: italic;">';
        html += processedData.type;
        html += '</td></tr></tfoot>';
      }
    } else {
// ??? items?嚗蝞???processed ?殉???
Object.keys(processedData).forEach(key => {
        if (key !== 'items') {
          html += '<tr style="border-bottom: 1px solid #f0f0f0;">';
          html += `<td style="padding: 8px 12px; font-weight: 500; width: 30%;">${key}</td>`;
          html += `<td style="padding: 8px 12px;">${processedData[key] || '-'}</td>`;
          html += '</tr>';
        }
      });
    }
  } else {
// ??? processed ?鞊??嚗蝞??□??曇????? raw??
Object.keys(data).forEach(key => {
      if (key !== 'raw') {
        const value = data[key];
        // ?????????null
        if (value !== '' && value !== null && value !== undefined) {
          html += '<tr style="border-bottom: 1px solid #f0f0f0;">';
          html += `<td style="padding: 8px 12px; font-weight: 500; width: 30%;">${key}</td>`;
          html += `<td style="padding: 8px 12px;">${typeof value === 'object' ? JSON.stringify(value) : value}</td>`;
          html += '</tr>';
        }
      }
    });
  }
  
  html += '</table>';
  return html;
};

/**
 * ??? AI ????荒??????base64 ?鞊????謜冪 HTML ?萄赯? * ?????JSON ?瞉??????base64 ??????????殉??????謅?? */
const extractAiAnalysisResult = (userMessage) => {
// ????蝞??謘??????∪??澗??鈭???
if (!userMessage || typeof userMessage !== 'string') {
    return userMessage;
  }

// ?潘撓貔??秋???迎???JSON ?瞉???隤?{ ??[ ??∵髡??
const trimmed = userMessage.trim();
  if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) {
    // ??謢 JSON ?瞉??謆?鈭??豯??迎???殉不?????殉?????
    return userMessage;
  }

  try {
    // ?謅疵?????JSON
    const parsed = JSON.parse(userMessage);
    
// ?潘撓貔??秋???荒? base64 ?鞈??????
const hasRawField = parsed && typeof parsed === 'object' && 'raw' in parsed;
    const rawValue = hasRawField ? parsed.raw : null;
    const hasBase64 = rawValue && typeof rawValue === 'string' && 
                      (rawValue.length > 1000 || rawValue.includes('base64') || 
                       /^[A-Za-z0-9+/=]+$/.test(rawValue.substring(0, 100)));
    
// ?????荒? base64 ?鞊??摰??raw ?殉???
if (hasBase64) {
      const cleaned = { ...parsed };
      delete cleaned.raw;
      
// ??????綽??????□??曇???改???HTML ?萄赯?
if (Object.keys(cleaned).length > 0) {
        return convertJsonToHtmlTable(cleaned);
      } else {
// ?????賂??raw ?殉??曉????豯??瑞?蝮??
        return '[Image data - AI generated content, not displayed]';
      }
    }
    
// ????????base64???改???HTML ?萄赯?
return convertJsonToHtmlTable(parsed);
  } catch (e) {
    // ????剜?????鞈???瞉???芰???JSON ?謘????橘???﹝????
    // ?潘撓貔??秋???荒? base64 ?摮萄???????殉?瘜菟???
    if (userMessage.length > 10000 && /^[A-Za-z0-9+/=\s]+$/.test(userMessage.substring(0, 100))) {
// ??迎???base64 ?殉?瘜菟???擗?????賤蹓?
        return '[Image data - AI generated content, not displayed]';
    }
    
    // ?銵?擗???賹???寞?????鞈???瞉???芰???JSON ?謘橘?橘???殉不?
    return userMessage;
  }
};

const PendingTasksPage = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [pendingEforms, setPendingEforms] = useState([]);
  const [approvedEforms, setApprovedEforms] = useState([]);
  const [rejectedEforms, setRejectedEforms] = useState([]);
  const [manualPendingEforms, setManualPendingEforms] = useState([]);
  const [manualRespondedEforms, setManualRespondedEforms] = useState([]);
  const [definitions, setDefinitions] = useState([]);
  const [definitionCounts, setDefinitionCounts] = useState({ total: 0, byId: {} });
  const [loadingDefinitionCounts, setLoadingDefinitionCounts] = useState(false);
  const [activeTab, setActiveTab] = useState('pending');
  const [viewMode, setViewMode] = useState('normal'); // 'normal' or 'manual'
  const [selectedEform, setSelectedEform] = useState(null);
  const [approveModalVisible, setApproveModalVisible] = useState(false);
  const [rejectModalVisible, setRejectModalVisible] = useState(false);
  const [approvalNote, setApprovalNote] = useState('');
  const [processingEform, setProcessingEform] = useState(null);
  const [savingFormContent, setSavingFormContent] = useState(false);
  const [exportingEmbedFormPdf, setExportingEmbedFormPdf] = useState(false);
  const [embeddedFormVisible, setEmbeddedFormVisible] = useState(false);
  const [embeddedFormInstance, setEmbeddedFormInstance] = useState(null);
  const [loadingEmbeddedForm, setLoadingEmbeddedForm] = useState(false);
  const [embedFormIframeSrc, setEmbedFormIframeSrc] = useState('');
  const [embedFormIframeLoaded, setEmbedFormIframeLoaded] = useState(0);
  const [relatedAttachments, setRelatedAttachments] = useState([]);
  const [loadingAttachments, setLoadingAttachments] = useState(false);
  const [lightboxVisible, setLightboxVisible] = useState(false);
  const [lightboxFile, setLightboxFile] = useState(null);
  const [lightboxFiles, setLightboxFiles] = useState([]);
  const [lightboxCurrentIndex, setLightboxCurrentIndex] = useState(0);
  const [userTimezoneOffset, setUserTimezoneOffset] = useState('UTC+8'); // ?綜此?????蹇?
  
// ???蛛????localStorage key ??踐??殉朵??蹎?/?????望??
const EXPAND_PREFERENCE_KEY = 'pendingTasksExpandAllPreference';
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  
// ?撖?????鞈?????
const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [batchProcessingModalVisible, setBatchProcessingModalVisible] = useState(false);
  const [batchAction, setBatchAction] = useState('');
  const [batchNote, setBatchNote] = useState('');
  const [processingBatch, setProcessingBatch] = useState(false);
  const [exporting, setExporting] = useState(false);

  // Apply custom table style on mount
  useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.textContent = customTableStyle;
    document.head.appendChild(styleElement);
    
    return () => {
      if (document.head.contains(styleElement)) {
        document.head.removeChild(styleElement);
      }
    };
  }, []);

  // Debug: log embeddedFormInstance changes
  useEffect(() => {
    if (embeddedFormInstance) {
      console.log('embeddedFormInstance ?謆??', embeddedFormInstance);
      console.log('userMessage ??????:', embeddedFormInstance.userMessage);
      console.log('approvalNote ??????:', embeddedFormInstance.approvalNote);
    }
  }, [embeddedFormInstance]);

// ????豲? mount?蹓??[filters] / [activeTab] effect ??mount ?蹇? loadAllTabData ????怨?謒?
const isInitialMount = useRef(true);
  // 存放最新版 load 函式供 polling interval 呼叫，避免 stale closure
  const autoRefreshFnsRef = useRef({});

  // ????獢??選???選????Cleave.js ?瞉???($##,###.##)?謑?賹??選????Flatpickr
  const cleaveInstancesRef = useRef([]);
  const flatpickrInstancesRef = useRef([]);
  const embeddedFormContainerRef = useRef(null);
  const embedFormIframeRef = useRef(null);

  const applyFormEnhancements = useCallback((container, calendarAppendTo, options) => {
    if (!container) return;
    const skipFlatpickr = options?.skipFlatpickr === true;
    cleaveInstancesRef.current.forEach(c => c?.destroy?.());
    cleaveInstancesRef.current = [];
    if (!skipFlatpickr) {
      flatpickrInstancesRef.current.forEach(fp => fp?.destroy?.());
      flatpickrInstancesRef.current = [];
    }
    const currencyInputs = container.querySelectorAll('input[data-input-type="currency"]');
    currencyInputs.forEach(el => {
      try {
        const cleave = new Cleave(el, {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalMark: '.',
          delimiter: ',',
          prefix: '$',
          numeralDecimalScale: 2,
          numeralIntegerScale: 15
        });
        cleaveInstancesRef.current.push(cleave);
      } catch (err) {
        console.warn('Cleave.js init failed for currency input:', err);
      }
    });
    if (skipFlatpickr) return;
    const dateInputs = container.querySelectorAll('input[data-input-type="date"]');
    dateInputs.forEach(el => {
      try {
        const formatKey = el.getAttribute('data-date-format') || 'YYYY-MM-DD';
        const fpFormat = getFlatpickrDateFormat(formatKey);
        const dataValue = (el.getAttribute('data-value') || '').trim();
        const rawValue = (el.value || el.getAttribute('value') || '').trim();
        let defaultDate = null;
        if (dataValue && isIsoDateString(dataValue)) defaultDate = dataValue;
        else if (rawValue) {
          if (isIsoDateString(rawValue)) defaultDate = rawValue;
          else {
            const iso = parseDisplayToIso(rawValue, formatKey);
            if (iso) defaultDate = iso;
          }
        }
        const defaultDateObj = defaultDate ? new Date(defaultDate + 'T12:00:00') : null;
        const validDefaultDate = defaultDateObj && !isNaN(defaultDateObj.getTime()) ? defaultDateObj : (defaultDate || undefined);
        const fpOptions = {
          dateFormat: fpFormat,
          defaultDate: validDefaultDate,
          allowInput: true,
          onChange(selectedDates, dateStr) {
            el.setAttribute('value', dateStr);
            if (selectedDates[0]) el.setAttribute('data-value', dateToLocalIsoString(selectedDates[0]));
          }
        };
        if (calendarAppendTo) fpOptions.appendTo = calendarAppendTo;
        const fp = flatpickr(el, fpOptions);
        flatpickrInstancesRef.current.push(fp);
      } catch (err) {
        console.warn('Flatpickr init failed for date input:', err);
      }
    });
  }, []);

  // ?萄謘????城???HTML ??iframe Blob URL ?輯???
  useEffect(() => {
    if (!embeddedFormInstance) {
      setEmbedFormIframeSrc(prev => {
        if (prev) URL.revokeObjectURL(prev);
        return '';
      });
      return;
    }
    const html = embeddedFormInstance.filledHtmlCode || embeddedFormInstance.htmlCode || '';
    if (!html) {
      setEmbedFormIframeSrc(prev => {
        if (prev) URL.revokeObjectURL(prev);
        return '';
      });
      return;
    }
    // MetaFlows?城?謢賃冪 JSON?? WorkflowMonitor ?閰??憳?? EFormContentViewer ??????iframe Blob
    if (embeddedFormInstance.fillType === 'MetaFlows' && html.trim().startsWith('{')) {
      setEmbedFormIframeSrc(prev => {
        if (prev) URL.revokeObjectURL(prev);
        return '';
      });
      return;
    }
    const url = buildFormPreviewBlobUrl(html);
    setEmbedFormIframeSrc(prev => {
      if (prev) URL.revokeObjectURL(prev);
      return url;
    });
    return () => {
      URL.revokeObjectURL(url);
    };
  }, [embeddedFormInstance]);

  useEffect(() => {
    if (!embeddedFormVisible || loadingEmbeddedForm || !embeddedFormInstance) return;
    const rawHtml = embeddedFormInstance.filledHtmlCode || embeddedFormInstance.htmlCode || '';
    if (!rawHtml) return;
    if (embeddedFormInstance.fillType === 'MetaFlows' && rawHtml.trim().startsWith('{')) return;
    const tryApply = (attempt = 0) => {
      const iframe = embedFormIframeRef.current;
      const iframeBody = iframe?.contentDocument?.body;
      const container = iframeBody
        || embeddedFormContainerRef.current
        || document.querySelector('.embedded-form-modal .form-content-inner')
        || document.querySelector('.ant-modal-open .form-content-inner');
      if (container) {
        const calendarAppendTo = iframeBody ? iframe?.parentElement : undefined;
        applyFormEnhancements(container, calendarAppendTo);
      } else if (attempt < 5) {
        setTimeout(() => tryApply(attempt + 1), 200 * (attempt + 1));
      }
    };
    const timer = setTimeout(tryApply, 50);
    return () => {
      clearTimeout(timer);
      cleaveInstancesRef.current.forEach(c => c?.destroy?.());
      cleaveInstancesRef.current = [];
      flatpickrInstancesRef.current.forEach(fp => fp?.destroy?.());
      flatpickrInstancesRef.current = [];
    };
  }, [embeddedFormVisible, embeddedFormInstance?.id, embeddedFormInstance?.htmlCode, embeddedFormInstance?.filledHtmlCode, embeddedFormInstance?.fillType, loadingEmbeddedForm, embedFormIframeSrc, embedFormIframeLoaded, applyFormEnhancements]);
  const [statusChangeModalVisible, setStatusChangeModalVisible] = useState(false);
  const [statusChangeTarget, setStatusChangeTarget] = useState(null);
  const [statusChangeNote, setStatusChangeNote] = useState('');
  const [statistics, setStatistics] = useState({
    total: 0,
    pending: 0,
    overdue: 0,
    urgent: 0
  });
  
// ???????株釭???
const [counts, setCounts] = useState({
    pending: 0,
    approved: 0,
    rejected: 0,
    manualPending: 0,
    manualResponded: 0
  });
  const [fillTypeStatistics, setFillTypeStatistics] = useState({
    aiFillCount: 0,
    dataFillCount: 0,
    manualFillCount: 0
  });
  const [filters, setFilters] = useState(getInitialPendingTasksFilters);

  useEffect(() => {
    persistPendingTasksFilters(filters);
  }, [filters]);

  // ?????踝??蹇??賤蹓?
  useEffect(() => {
    const userInfo = localStorage.getItem('userInfo');
    console.log('PendingTasksPage - loading user timezone info');
    console.log('?? userInfo:', userInfo);
    
    if (userInfo) {
      try {
        const parsedUserInfo = JSON.parse(userInfo);
        console.log('?? parsedUserInfo:', parsedUserInfo);
        console.log('?? parsedUserInfo.timezone:', parsedUserInfo.timezone);
        
        if (parsedUserInfo.timezone) {
          setUserTimezoneOffset(parsedUserInfo.timezone);
          console.log('?? ?桀???userTimezoneOffset ??', parsedUserInfo.timezone);
        } else {
          console.log('?? ??? timezone ?殉??曉??寡?????歹???UTC+8');
        }
      } catch (error) {
        console.error('?????踝??賤蹓??:', error);
      }
    } else {
      console.log('?? ??? userInfo??????歹???UTC+8');
    }
  }, []);

  useEffect(() => {
    loadAllTabData();
    loadStatistics();
    loadFillTypeStatistics();
    loadDefinitions();
    loadDefinitionCounts();
// ?豲???舀???綽??????
isInitialMount.current = false;
  }, []);

  // 30 秒自動 polling，與 WorkflowMonitorPage 一致；透過 ref 取得最新 load 函式，避免 stale closure
  useEffect(() => {
    const POLL_INTERVAL = 30 * 1000;
    const id = setInterval(() => {
      autoRefreshFnsRef.current.loadAllTabData?.();
      autoRefreshFnsRef.current.loadStatistics?.();
      autoRefreshFnsRef.current.loadDefinitionCounts?.();
    }, POLL_INTERVAL);
    return () => clearInterval(id);
  }, []);

  const loadDefinitions = async () => {
    try {
      const response = await fetch('/api/eforms?page=1&pageSize=1000', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      if (response.ok) {
        const data = await response.json();
        setDefinitions(data.data || []);
      }
    } catch (error) {
      console.error('??舫?賃??堊垓???:', error);
    }
  };

  useEffect(() => {
    // ?豲? mount ?蹇革????頦???loadAllTabData ???
    if (isInitialMount.current) return;
    loadAllTabData();
    loadFillTypeStatistics();
    loadDefinitionCounts();
  }, [filters]);

  useEffect(() => {
    // ?豲? mount ?蹇革????頦???loadAllTabData ???
    if (isInitialMount.current) return;
    loadAllEforms();
    loadDefinitionCounts();
  }, [activeTab]);

  useEffect(() => {
    // ?豲? mount ?蹇革??????賹秧???[viewMode] effect?蹓??setActiveTab ?怨?謒?[activeTab] effect ????
    if (isInitialMount.current) return;
    setActiveTab('pending');
    setSelectedRowKeys([]);
    setSelectedRows([]);
    loadFillTypeStatistics();
    loadAllEforms();
    loadDefinitionCounts();
  }, [viewMode]);

  // ????殷???萄赯菜?謢嗆撞
  const getTableScrollHeight = () => {
// ?蝞??朱瞍脩?謜?蝞?????????
let baseHeight = 420; // ?方葭??蝞??朱瞍脣??潑?踐???蹓魂????
    
// ?????歹????遴高?????選?????????朱瞍?
if (selectedRowKeys.length > 0) {
      baseHeight += 60;
    }
    
    return `calc(100vh - ${baseHeight}px)`;
  };

  // ?蹎?????tab ???謍???踐??豲??謘??輯??抒???????鞈?
  const loadAllTabData = async () => {
    try {
      // Load all tabs in parallel
      await Promise.all([
        loadPendingEforms(false),
        loadApprovedEforms(false),
        loadRejectedEforms(false),
        loadManualPendingEforms(false),
        loadManualRespondedEforms(false)
      ]);
    } catch (error) {
      console.error('Failed to load all tab data:', error);
    }
  };

  const loadAllEforms = async () => {
    if (viewMode === 'manual') {
      switch (activeTab) {
        case 'pending':
          await loadManualPendingEforms();
          break;
        case 'responded':
          await loadManualRespondedEforms();
          break;
        default:
          await loadManualPendingEforms();
      }
    } else {
      switch (activeTab) {
        case 'pending':
          await loadPendingEforms();
          break;
        case 'approved':
          await loadApprovedEforms();
          break;
        case 'rejected':
          await loadRejectedEforms();
          break;
        default:
          await loadPendingEforms();
      }
    }
  };

  const loadPendingEforms = async (setLoadingState = true) => {
    if (setLoadingState) setLoading(true);
    try {
      // ?輯撒?????????塗
      const { current, pageSize } = paginationStates.pending;
      const params = new URLSearchParams({
        page: current.toString(),
        pageSize: pageSize.toString()
      });

      if (filters.searchText) {
        params.append('search', filters.searchText);
      }

      if (filters.definition !== 'all') {
        params.append('eformId', filters.definition);
      }

      if (filters.dateRange && filters.dateRange.length === 2) {
        params.append('createdDateFrom', filters.dateRange[0].toISOString());
        params.append('createdDateTo', filters.dateRange[1].toISOString());
      }

      const response = await fetch(`/api/eforminstances/pending?${params}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to load pending tasks: ${response.status}`);
      }

      const data = await response.json();

      const formattedData = data.data?.map(item => ({
        id: item.id,
        formName: item.formName,
        instanceName: item.instanceName,
        status: item.status,
        fillType: item.fillType,
        priority: item.priority || 'Medium',
        createdBy: item.createdBy,
        createdAt: item.createdAt,
        dueDate: item.dueDate,
        workflowInstanceId: item.workflowInstanceId ?? item.workflowExecutionId,
        approveButtonLabel: item.approveButtonLabel,
        rejectButtonLabel: item.rejectButtonLabel,
        approvalLabels: item.approvalLabels,
        userMessage: item.userMessage,
        accessToken: item.accessToken,
        formData: {},
        fieldDisplaySettings: Array.isArray(item.fieldDisplaySettings)
          ? item.fieldDisplaySettings
          : (item.fieldDisplaySettings ? (() => { try { return JSON.parse(item.fieldDisplaySettings); } catch { return []; } })() : []),
        parsedFieldValues: item.parsedFieldValues || {},
        pvDisplaySettings: Array.isArray(item.pvDisplaySettings) ? item.pvDisplaySettings : [],
        parsedPvValues: item.parsedPvValues || {},
        recipientName: item.recipientName,
        recipientWhatsAppNo: item.recipientWhatsAppNo,
        updatedAt: item.updatedAt,
        approvalAt: item.approvalAt
      })) || [];
      
      // Filter out Manual Fill records - these don't need manual processing
      const filteredData = formattedData.filter(item => item.fillType !== 'Manual');
      
      setPendingEforms(filteredData);

// ?皝??殷???- ?輯撒?PI擗??????鞈??? Manual Fill ?綽??株都?脣??      // ???契?謕????秋撩???data.total ????Manual Fill ????
const manualCount = formattedData.length - filteredData.length;
      setCounts(prev => ({
        ...prev,
        pending: Math.max(0, (data.total || 0) - manualCount)
      }));
      
    } catch (error) {
      console.error('Failed to load pending tasks:', error);
      message.error(t('pendingTasks.loadPendingTasksFailed') + ': ' + error.message);
      
      // If API fails, use empty array
      setPendingEforms([]);
    } finally {
      if (setLoadingState) setLoading(false);
    }
  };

  const loadApprovedEforms = async (setLoadingState = true) => {
    if (setLoadingState) setLoading(true);
    try {
      // ?輯撒?????????塗
      const { current, pageSize } = paginationStates.approved;
      const params = new URLSearchParams({
        page: current.toString(),
        pageSize: pageSize.toString()
      });

      if (filters.searchText) {
        params.append('search', filters.searchText);
      }

      if (filters.definition !== 'all') {
        params.append('eformId', filters.definition);
      }

      if (filters.dateRange && filters.dateRange.length === 2) {
        params.append('createdDateFrom', filters.dateRange[0].toISOString());
        params.append('createdDateTo', filters.dateRange[1].toISOString());
      }

      const response = await fetch(`/api/eforminstances/approved?${params}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to load approved forms: ${response.status}`);
      }

      const data = await response.json();

      const formattedData = data.data?.map(item => ({
        id: item.id,
        formName: item.formName,
        instanceName: item.instanceName,
        status: item.status,
        fillType: item.fillType,
        priority: item.priority || 'Medium',
        createdBy: item.createdBy,
        createdAt: item.createdAt,
        dueDate: item.dueDate,
        workflowInstanceId: item.workflowInstanceId ?? item.workflowExecutionId,
        approveButtonLabel: item.approveButtonLabel,
        rejectButtonLabel: item.rejectButtonLabel,
        approvalLabels: item.approvalLabels,
        userMessage: item.userMessage,
        accessToken: item.accessToken,
        formData: {},
        fieldDisplaySettings: Array.isArray(item.fieldDisplaySettings)
          ? item.fieldDisplaySettings
          : (item.fieldDisplaySettings ? (() => { try { return JSON.parse(item.fieldDisplaySettings); } catch { return []; } })() : []),
        parsedFieldValues: item.parsedFieldValues || {},
        pvDisplaySettings: Array.isArray(item.pvDisplaySettings) ? item.pvDisplaySettings : [],
        parsedPvValues: item.parsedPvValues || {},
        recipientName: item.recipientName,
        recipientWhatsAppNo: item.recipientWhatsAppNo,
        updatedAt: item.updatedAt,
        approvalAt: item.approvalAt,
        approvalBy: item.approvalBy
      })) || [];
      
      setApprovedEforms(formattedData);
      
// ?皝??殷???- ?輯撒?PI擗???????
setCounts(prev => ({
        ...prev,
        approved: data.total || formattedData.length
      }));
      
    } catch (error) {
      console.error('Failed to load approved forms:', error);
      message.error('??舀??恬???獢隞?? ' + error.message);
      setApprovedEforms([]);
    } finally {
      if (setLoadingState) setLoading(false);
    }
  };

  const loadRejectedEforms = async (setLoadingState = true) => {
    if (setLoadingState) setLoading(true);
    try {
      // ?輯撒?????????塗
      const { current, pageSize } = paginationStates.rejected;
      const params = new URLSearchParams({
        page: current.toString(),
        pageSize: pageSize.toString()
      });

      if (filters.searchText) {
        params.append('search', filters.searchText);
      }

      if (filters.definition !== 'all') {
        params.append('eformId', filters.definition);
      }

      if (filters.dateRange && filters.dateRange.length === 2) {
        params.append('createdDateFrom', filters.dateRange[0].toISOString());
        params.append('createdDateTo', filters.dateRange[1].toISOString());
      }

      const response = await fetch(`/api/eforminstances/rejected?${params}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to load rejected forms: ${response.status}`);
      }

      const data = await response.json();

      const formattedData = data.data?.map(item => ({
        id: item.id,
        formName: item.formName,
        instanceName: item.instanceName,
        status: item.status,
        fillType: item.fillType,
        priority: item.priority || 'Medium',
        createdBy: item.createdBy,
        createdAt: item.createdAt,
        dueDate: item.dueDate,
        workflowInstanceId: item.workflowInstanceId ?? item.workflowExecutionId,
        approveButtonLabel: item.approveButtonLabel,
        rejectButtonLabel: item.rejectButtonLabel,
        approvalLabels: item.approvalLabels,
        userMessage: item.userMessage,
        accessToken: item.accessToken,
        formData: {},
        fieldDisplaySettings: Array.isArray(item.fieldDisplaySettings)
          ? item.fieldDisplaySettings
          : (item.fieldDisplaySettings ? (() => { try { return JSON.parse(item.fieldDisplaySettings); } catch { return []; } })() : []),
        parsedFieldValues: item.parsedFieldValues || {},
        pvDisplaySettings: Array.isArray(item.pvDisplaySettings) ? item.pvDisplaySettings : [],
        parsedPvValues: item.parsedPvValues || {},
        recipientName: item.recipientName,
        recipientWhatsAppNo: item.recipientWhatsAppNo,
        updatedAt: item.updatedAt,
        rejectedAt: item.rejectedAt,
        rejectedBy: item.rejectedBy
      })) || [];
      
      setRejectedEforms(formattedData);
      
// ?皝??殷???- ?輯撒?PI擗???????
setCounts(prev => ({
        ...prev,
        rejected: data.total || formattedData.length
      }));
      
    } catch (error) {
      console.error('Failed to load rejected forms:', error);
      message.error('??舀????荒??獢隞?? ' + error.message);
      setRejectedEforms([]);
    } finally {
      if (setLoadingState) setLoading(false);
    }
  };

  const loadStatistics = async () => {
    try {
      const response = await fetch('/api/eforminstances/statistics/pending', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to load statistics: ${response.status}`);
      }

      const data = await response.json();
      setStatistics(data);
    } catch (error) {
      console.error('Failed to load statistics:', error);
      
      // If API fails, use default values
      setStatistics({
        total: 0,
        pending: 0,
        overdue: 0,
        urgent: 0
      });
    }
  };

  const loadFillTypeStatistics = async () => {
    try {
      const params = new URLSearchParams();
      if (filters.definition && filters.definition !== 'all') {
        params.append('eformId', filters.definition);
      }
      if (filters.dateRange && filters.dateRange[0]) {
        params.append('createdDateFrom', filters.dateRange[0].startOf('day').toISOString());
      }
      if (filters.dateRange && filters.dateRange[1]) {
        params.append('createdDateTo', filters.dateRange[1].endOf('day').toISOString());
      }
      const response = await fetch(`/api/eforminstances/statistics/fillType?${params.toString()}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to load Fill Type statistics: ${response.status}`);
      }

      const data = await response.json();
      setFillTypeStatistics(data);
    } catch (error) {
      console.error('Failed to load Fill Type statistics:', error);
      
      // If API fails, use default values
      setFillTypeStatistics({
        aiFillCount: 0,
        dataFillCount: 0,
        manualFillCount: 0
      });
    }
  };

  const loadManualPendingEforms = async (setLoadingState = true) => {
    if (setLoadingState) setLoading(true);
    try {
      // ?輯撒?????????塗
      const { current, pageSize } = paginationStates.manualPending;
      const params = new URLSearchParams({
        page: current.toString(),
        pageSize: pageSize.toString()
      });

      if (filters.searchText) {
        params.append('search', filters.searchText);
      }

      if (filters.definition !== 'all') {
        params.append('eformId', filters.definition);
      }

      if (filters.dateRange && filters.dateRange.length === 2) {
        params.append('createdDateFrom', filters.dateRange[0].toISOString());
        params.append('createdDateTo', filters.dateRange[1].toISOString());
      }

      const response = await fetch(`/api/eforminstances/manual/pending?${params}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to load manual pending forms: ${response.status}`);
      }

      const data = await response.json();

      const formattedData = data.data?.map(item => ({
        id: item.id,
        formName: item.formName,
        instanceName: item.instanceName,
        status: item.status,
        fillType: item.fillType,
        priority: item.priority || 'Medium',
        createdBy: item.createdBy,
        createdAt: item.createdAt,
        dueDate: item.dueDate,
        workflowInstanceId: item.workflowInstanceId ?? item.workflowExecutionId,
        approveButtonLabel: item.approveButtonLabel,
        rejectButtonLabel: item.rejectButtonLabel,
        approvalLabels: item.approvalLabels,
        userMessage: item.userMessage,
        recipientWhatsAppNo: item.recipientWhatsAppNo,
        recipientName: item.recipientName,
        accessToken: item.accessToken,
        formData: {},
        fieldDisplaySettings: Array.isArray(item.fieldDisplaySettings)
          ? item.fieldDisplaySettings
          : (item.fieldDisplaySettings ? (() => { try { return JSON.parse(item.fieldDisplaySettings); } catch { return []; } })() : []),
        parsedFieldValues: item.parsedFieldValues || {},
        pvDisplaySettings: Array.isArray(item.pvDisplaySettings) ? item.pvDisplaySettings : [],
        parsedPvValues: item.parsedPvValues || {},
        updatedAt: item.updatedAt,
        approvalAt: item.approvalAt
      })) || [];
      
      setManualPendingEforms(formattedData);
      
// ?皝??殷???- ?輯撒?PI擗???????
setCounts(prev => ({
        ...prev,
        manualPending: data.total || formattedData.length
      }));
      
    } catch (error) {
      console.error('Failed to load manual pending forms:', error);
      message.error('????????綽???色?獢隞?? ' + error.message);
      setManualPendingEforms([]);
    } finally {
      if (setLoadingState) setLoading(false);
    }
  };

  const loadManualRespondedEforms = async (setLoadingState = true) => {
    if (setLoadingState) setLoading(true);
    try {
      // ?輯撒?????????塗
      const { current, pageSize } = paginationStates.manualResponded;
      const params = new URLSearchParams({
        page: current.toString(),
        pageSize: pageSize.toString()
      });

      if (filters.searchText) {
        params.append('search', filters.searchText);
      }

      if (filters.definition !== 'all') {
        params.append('eformId', filters.definition);
      }

      if (filters.dateRange && filters.dateRange.length === 2) {
        params.append('createdDateFrom', filters.dateRange[0].toISOString());
        params.append('createdDateTo', filters.dateRange[1].toISOString());
      }

      const response = await fetch(`/api/eforminstances/manual/responded?${params}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to load manual responded forms: ${response.status}`);
      }

      const data = await response.json();

      const formattedData = data.data?.map(item => ({
        id: item.id,
        formName: item.formName,
        instanceName: item.instanceName,
        status: item.status,
        fillType: item.fillType,
        priority: item.priority || 'Medium',
        createdBy: item.createdBy,
        createdAt: item.createdAt,
        updatedAt: item.updatedAt,
        dueDate: item.dueDate,
        workflowInstanceId: item.workflowInstanceId ?? item.workflowExecutionId,
        approveButtonLabel: item.approveButtonLabel,
        rejectButtonLabel: item.rejectButtonLabel,
        approvalLabels: item.approvalLabels,
        userMessage: item.userMessage,
        recipientWhatsAppNo: item.recipientWhatsAppNo,
        recipientName: item.recipientName,
        accessToken: item.accessToken,
        approvalBy: item.approvalBy,
        approvalAt: item.approvalAt,
        rejectedBy: item.rejectedBy,
        rejectedAt: item.rejectedAt,
        formData: {},
        fieldDisplaySettings: Array.isArray(item.fieldDisplaySettings)
          ? item.fieldDisplaySettings
          : (item.fieldDisplaySettings ? (() => { try { return JSON.parse(item.fieldDisplaySettings); } catch { return []; } })() : []),
        parsedFieldValues: item.parsedFieldValues || {},
        pvDisplaySettings: Array.isArray(item.pvDisplaySettings) ? item.pvDisplaySettings : [],
        parsedPvValues: item.parsedPvValues || {}
      })) || [];
      
      setManualRespondedEforms(formattedData);
      
// ?皝??殷???- ?輯撒?PI擗???????
setCounts(prev => ({
        ...prev,
        manualResponded: data.total || formattedData.length
      }));
      
    } catch (error) {
      console.error('Failed to load manual responded forms:', error);
      message.error('??????????????色?獢隞?? ' + error.message);
      setManualRespondedEforms([]);
    } finally {
      if (setLoadingState) setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setFilters(prev => ({ ...prev, searchText: value }));
  };

  const handleDefinitionFilter = (value) => {
    setFilters(prev => ({ ...prev, definition: value ?? 'all' }));
  };

  const getDefinitionCountListType = () => {
    if (viewMode === 'manual') {
      return activeTab === 'responded' ? 'manualResponded' : 'manualPending';
    }
    if (activeTab === 'approved') return 'approved';
    if (activeTab === 'rejected') return 'rejected';
    return 'pending';
  };

  const loadDefinitionCounts = async () => {
    setLoadingDefinitionCounts(true);
    try {
      const params = new URLSearchParams({ listType: getDefinitionCountListType() });
      if (filters.searchText) {
        params.append('search', filters.searchText);
      }
      if (filters.dateRange && filters.dateRange.length === 2) {
        params.append('createdDateFrom', filters.dateRange[0].toISOString());
        params.append('createdDateTo', filters.dateRange[1].toISOString());
      }
      const response = await fetch(`/api/eforminstances/statistics/by-definition?${params}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      if (!response.ok) throw new Error('Failed to load definition counts');
      const data = await response.json();
      const byId = {};
      (data.items || []).forEach((item) => {
        if (item.eformDefinitionId != null) {
          byId[String(item.eformDefinitionId)] = item.count;
        }
      });
      setDefinitionCounts({ total: data.total ?? 0, byId });
    } catch (error) {
      console.error('loadDefinitionCounts failed', error);
      setDefinitionCounts({ total: 0, byId: {} });
    } finally {
      setLoadingDefinitionCounts(false);
    }
  };

  // 每次 render 同步最新函式到 ref，供 polling interval 使用
  autoRefreshFnsRef.current = { loadAllTabData, loadStatistics, loadDefinitionCounts };

  const definitionTabItems = React.useMemo(() =>
    definitions
      .filter((def) => def.status !== 'I' && def.status !== 'D')
      .map((def) => ({
        id: def.id,
        name: def.name,
        count: definitionCounts.byId[String(def.id)] ?? 0
      })),
    [definitions, definitionCounts]
  );

  const fetchAllForExport = async (tabKey) => {
    const params = new URLSearchParams({ page: '1', pageSize: '10000' });
    if (filters.searchText) params.append('search', filters.searchText);
    if (filters.definition !== 'all') params.append('eformId', filters.definition);
    if (filters.dateRange && filters.dateRange.length === 2) {
      params.append('createdDateFrom', filters.dateRange[0].toISOString());
      params.append('createdDateTo', filters.dateRange[1].toISOString());
    }

    let endpoint = '';
    if (viewMode === 'manual') {
      endpoint = tabKey === 'responded'
        ? `/api/eforminstances/manual/responded?${params}`
        : `/api/eforminstances/manual/pending?${params}`;
    } else {
      if (tabKey === 'approved') endpoint = `/api/eforminstances/approved?${params}`;
      else if (tabKey === 'rejected') endpoint = `/api/eforminstances/rejected?${params}`;
      else endpoint = `/api/eforminstances/pending?${params}`;
    }

    const response = await fetch(endpoint, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();

    return (data.data || []).map(item => ({
      id: item.id,
      workflowInstanceId: item.workflowInstanceId ?? item.workflowExecutionId,
      formName: item.formName,
      instanceName: item.instanceName,
      status: item.status,
      fillType: item.fillType,
      createdBy: item.createdBy,
      createdAt: item.createdAt,
      updatedAt: item.updatedAt,
      approvalBy: item.approvalBy,
      approvalAt: item.approvalAt,
      rejectedBy: item.rejectedBy,
      fieldDisplaySettings: Array.isArray(item.fieldDisplaySettings)
        ? item.fieldDisplaySettings
        : (item.fieldDisplaySettings
            ? (() => { try { return JSON.parse(item.fieldDisplaySettings); } catch { return []; } })()
            : []),
      parsedFieldValues: item.parsedFieldValues || {},
      pvDisplaySettings: Array.isArray(item.pvDisplaySettings) ? item.pvDisplaySettings : [],
      parsedPvValues: item.parsedPvValues || {}
    }));
  };

  const handleExportExcel = async () => {
    if (filters.definition === 'all') return;
    setExporting(true);
    try {
      const allData = await fetchAllForExport(activeTab);
      if (!allData.length) {
        message.info(t('pendingTasks.noDataToExport') || '?????穿??蝞???');
        return;
      }

      const fieldLookupKey = (f) => f.rowKey || (f.jsonKey ? `${f.fieldId}::${f.jsonKey}` : f.fieldId);
      const pvLookupKey = (p) => p.rowKey || (p.jsonKey ? `${p.variableName}::${p.jsonKey}` : p.variableName);

      const firstRecord = allData[0];
      const visibleFields = (firstRecord.fieldDisplaySettings || [])
        .filter(f => f.showInList)
        .sort((a, b) => (a.order || 0) - (b.order || 0));
      const visiblePvs = (firstRecord.pvDisplaySettings || [])
        .sort((a, b) => (a.order || 0) - (b.order || 0));

      const baseHeaders = [
        t('pendingTasks.workflowInstanceId') || 'Workflow Instance ID',
        t('pendingTasks.formName') || 'Form Name',
        'Instance Name',
        t('pendingTasks.status') || 'Status',
        t('pendingTasks.fillType') || 'Fill Type',
        t('pendingTasks.applicant') || 'Applicant',
        t('pendingTasks.createdAt') || 'Created At',
        t('pendingTasks.updatedAt') || 'Updated At',
        ...(activeTab === 'approved' ? [
          t('pendingTasks.approvedBy') || 'Approved By',
          t('pendingTasks.approvalAt') || 'Approval At'
        ] : []),
        ...(activeTab === 'rejected' ? [t('pendingTasks.rejectedBy') || 'Rejected By'] : [])
      ];
      const fieldHeaders = visibleFields.map(f => f.displayLabel || f.fieldId);
      const pvHeaders = visiblePvs.map(p => p.displayLabel || p.variableName);
      const headers = [...baseHeaders, ...fieldHeaders, ...pvHeaders];

      const rows = allData.map(record => {
        const fmt = (v) => v ? TimezoneUtils.formatDateTime(v, 'YYYY-MM-DD HH:mm:ss') : '';
        const baseValues = [
          record.workflowInstanceId || '',
          record.formName || '',
          record.instanceName || '',
          record.status || '',
          record.fillType || '',
          record.createdBy || '',
          fmt(record.createdAt),
          fmt(record.updatedAt),
          ...(activeTab === 'approved' ? [record.approvalBy || '', fmt(record.approvalAt)] : []),
          ...(activeTab === 'rejected' ? [record.rejectedBy || ''] : [])
        ];
        const fieldValues = visibleFields.map(f => record.parsedFieldValues?.[fieldLookupKey(f)] ?? '');
        const pvValues = visiblePvs.map(p => record.parsedPvValues?.[pvLookupKey(p)] ?? '');
        return [...baseValues, ...fieldValues, ...pvValues];
      });

      const worksheetData = [headers, ...rows];
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const colWidths = headers.map((_, colIdx) => ({
        wch: Math.min(50, Math.max(...worksheetData.map(row => String(row[colIdx] ?? '').length)) + 2)
      }));
      worksheet['!cols'] = colWidths;

      const workbook = XLSX.utils.book_new();
      const sheetName = activeTab.charAt(0).toUpperCase() + activeTab.slice(1);
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

      const defName = definitions.find(d => d.id === filters.definition)?.name || 'export';
      const today = TimezoneUtils.formatDateTime(new Date(), 'YYYY-MM-DD');
      XLSX.writeFile(workbook, `${defName}_${sheetName}_${today}.xlsx`);
      message.success(t('pendingTasks.exportSuccess') || '??穿???');
    } catch (err) {
      console.error('Excel ??穿?剜??:', err);
      message.error(t('pendingTasks.exportFailed') || `??穿?剜??: ${err.message}`);
    } finally {
      setExporting(false);
    }
  };

  const handleDateRangeChange = (dates) => {
    setFilters(prev => ({ ...prev, dateRange: dates }));
  };

  const handleClearFilters = () => {
    setFilters(getDefaultPendingTasksFilters());
  };

// ??????record ??秋?????????啣??Form ?殉???OR ?播??????  // ?????toggle / useEffect / row style / ??Tab ??expandable expand button)?璇??蹓???????０??
const hasExpandableContent = (record) => {
    if (!record) return false;
    const hasField = Array.isArray(record.fieldDisplaySettings)
      && record.fieldDisplaySettings.some(f => f.showInList);
    const hasPv = Array.isArray(record.pvDisplaySettings) && record.pvDisplaySettings.length > 0;
    return hasField || hasPv;
  };

  // ?????賂豢???/????賹?
  const handleToggleExpandAll = () => {
    const currentEforms = getCurrentEforms();
    // fieldDisplaySettings / pvDisplaySettings ?謓?load ?蹇??????Array
    const expandableKeys = currentEforms
      .filter(hasExpandableContent)
      .map(record => record.id);
    
// ??????????????鞈Ｘ???????????????????
const allExpanded = expandableKeys.length > 0 && expandableKeys.every(key => expandedRowKeys.includes(key));
    
    if (allExpanded) {
      setExpandedRowKeys([]);
      try { localStorage.setItem(EXPAND_PREFERENCE_KEY, 'collapsed'); } catch (e) { /* ignore */ }
    } else {
      setExpandedRowKeys(expandableKeys);
      try { localStorage.setItem(EXPAND_PREFERENCE_KEY, 'expanded'); } catch (e) { /* ignore */ }
    }
  };

  const getCurrentEforms = () => {
    if (viewMode === 'manual') {
      switch (activeTab) {
        case 'pending':
          return manualPendingEforms;
        case 'responded':
          return manualRespondedEforms;
        default:
          return manualPendingEforms;
      }
    } else {
      switch (activeTab) {
        case 'pending':
          return pendingEforms;
        case 'approved':
          return approvedEforms;
        case 'rejected':
          return rejectedEforms;
        default:
          return pendingEforms;
      }
    }
  };

  // ??localStorage ?殉朵???????????望?謓???????謘??謕??鈭?????
  useEffect(() => {
    const currentEforms = getCurrentEforms();
    const expandableKeys = currentEforms
      .filter(hasExpandableContent)
      .map(record => record.id);
    const preference = (() => { try { return localStorage.getItem(EXPAND_PREFERENCE_KEY) || 'collapsed'; } catch (e) { return 'collapsed'; } })();
    if (preference === 'expanded' && expandableKeys.length > 0) {
      setExpandedRowKeys(expandableKeys);
    } else {
      setExpandedRowKeys([]);
    }
  }, [activeTab, viewMode, pendingEforms, approvedEforms, rejectedEforms, manualPendingEforms, manualRespondedEforms]);

  const handleTabChange = (key) => {
    setActiveTab(key);
    // ???????蹓??謒?撖??鞊?
    setSelectedRowKeys([]);
    setSelectedRows([]);
  };

  const handleViewEform = async (eform) => {
    setSelectedEform(eform);
    setEmbeddedFormVisible(true);
    await loadEmbeddedFormInstance(eform.id, eform);
  };

  const handleCloseEmbeddedForm = () => {
    setEmbedFormIframeSrc(prev => {
      if (prev) URL.revokeObjectURL(prev);
      return '';
    });
    setEmbeddedFormVisible(false);
    setEmbeddedFormInstance(null);
    setSelectedEform(null);
    setRelatedAttachments([]);
  };

  const renderModalTitle = () => {
    const isActionableForm = embeddedFormInstance && 
                             (embeddedFormInstance.fillType === 'AI' || embeddedFormInstance.fillType === 'Data') &&
                             embeddedFormInstance.status === 'Pending';
    
    const isManualFillForm = embeddedFormInstance && 
                             embeddedFormInstance.fillType === 'Manual';
    const embeddedApprovalLabels = getEFormApprovalLabels(embeddedFormInstance || selectedEform, t);

    const btnStyle = { borderRadius: 20, height: 32, display: 'inline-flex', alignItems: 'center' };
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <span style={{ fontSize: '16px', fontWeight: '600', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginRight: 8 }}>
          {`Form Instance: ${selectedEform?.formName || ''}`}
        </span>
        <div style={{ display: 'flex', gap: '8px', marginRight: '16px', flexShrink: 0, flexWrap: 'wrap' }}>
          {embeddedFormInstance && (
            <Button
              key="save-header"
              icon={<SaveOutlined />}
              onClick={saveFormContent}
              loading={savingFormContent}
              disabled={savingFormContent || exportingEmbedFormPdf}
              style={{ ...btnStyle, minWidth: 72 }}
            >
              {t('pendingTasks.save') || '儲存'}
            </Button>
          )}
          {embeddedFormInstance && canExportEformToPdf(embeddedFormInstance.fillType, embeddedFormInstance.filledHtmlCode || embeddedFormInstance.htmlCode || '') && (
            <Button
              key="export-pdf-header"
              icon={<FilePdfOutlined />}
              loading={exportingEmbedFormPdf}
              disabled={savingFormContent}
              onClick={handleExportEmbedFormPdf}
              style={{ ...btnStyle, minWidth: 96 }}
            >
              {t('common.exportPdf') || '匯出 PDF'}
            </Button>
          )}
          {isActionableForm && (
            <>
              <Button
                key="approve-header"
                type="primary"
                icon={<CheckCircleOutlined />}
                onClick={() => handleApprove(selectedEform)}
                style={{
                  ...btnStyle,
                  backgroundColor: '#52c41a',
                  borderColor: '#52c41a',
                  minWidth: 80,
                }}
              >
                {embeddedApprovalLabels.approve}
              </Button>
              <Button
                key="reject-header"
                type="primary"
                danger
                icon={<CloseCircleOutlined />}
                onClick={() => handleReject(selectedEform)}
                style={{ ...btnStyle, minWidth: 80 }}
              >
                {embeddedApprovalLabels.reject}
              </Button>
            </>
          )}
          {isManualFillForm && (
            <Button
              key="submitForm-header"
              type="primary"
              icon={<CheckCircleOutlined />}
              onClick={handleSubmitForm}
              style={{
                ...btnStyle,
                backgroundColor: embeddedFormInstance.status === 'Submitted' ? '#52c41a' : '#1890ff',
                borderColor: embeddedFormInstance.status === 'Submitted' ? '#52c41a' : '#1890ff',
                minWidth: 100,
              }}
            >
              {embeddedFormInstance.status === 'Submitted' ? t('pendingTasks.resubmitForm') : t('pendingTasks.submitForm')}
            </Button>
          )}
          <Button
            key="newTab-header"
            type="default"
            onClick={() => window.open(`/eform-instance/${selectedEform?.id}`, '_blank')}
            style={{ ...btnStyle, minWidth: 80 }}
          >
            {t('pendingTasks.openInNewTab')}
          </Button>
        </div>
      </div>
    );
  };

  const loadEmbeddedFormInstance = async (instanceId, eform = null) => {
    setLoadingEmbeddedForm(true);
    try {
      console.log('Loading embedded form instance:', instanceId);
      console.log('selectedEform:', selectedEform);
      console.log('passed eform:', eform);
      
// ?輯撒???喉??eform ??塗??selectedEform ????
const currentEform = eform || selectedEform;
      
      // ?潘撓貔??秋???Manual Fill ?萄謘????謚恃????秋撒? eform ?????accessToken
      const isManualFill = currentEform?.fillType === 'Manual';
      const accessToken = currentEform?.accessToken;
      
      console.log('isManualFill:', isManualFill);
      console.log('accessToken from eform:', accessToken);
      console.log('currentEform in loadEmbeddedFormInstance:', currentEform);
      console.log('currentEform.workflowInstanceId:', currentEform?.workflowInstanceId);
      
      // ??謘??拆貝?鈭?????踝??謆?銋抵??????API ?∟???????accessToken
      let url = `/api/eforminstances/${instanceId}`;
      console.log('Using internal API endpoint for logged-in user:', url);
      
      console.log('Loading embedded form with URL:', url);
      
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to load form instance: ${response.status}`);
      }

      const data = await response.json();
      setEmbeddedFormInstance(data);
      
      // ???鞈?????蹌??eform ??塗?漲?⊿豲??????workflowInstanceId
      await loadRelatedAttachments(instanceId, currentEform);
    } catch (error) {
      console.error('Failed to load embedded form instance:', error);
      message.error('??舫?賃????剜??: ' + error.message);
      setEmbeddedFormInstance(null);
    } finally {
      setLoadingEmbeddedForm(false);
    }
  };

  const loadRelatedAttachments = async (instanceId, eform = null) => {
    setLoadingAttachments(true);
    try {
      // ?輯撒???喉??eform ??塗?謘?????????獢蟡?????? workflowInstanceId
      const currentEform = eform || selectedEform || embeddedFormInstance;
      let workflowInstanceId = currentEform?.workflowInstanceId;
      
// ??? workflowInstanceId ???????謅疵??instanceName ?????
if (!workflowInstanceId && currentEform?.instanceName) {
        const match = currentEform.instanceName.match(/_(\d+)_/);
        if (match) {
          workflowInstanceId = match[1];
          console.log('Extracted workflowInstanceId from instanceName:', workflowInstanceId);
        }
      }
      
      console.log('Loading related attachments for eForm instance:', instanceId);
      console.log('Current eform:', currentEform);
      console.log('Workflow instance ID:', workflowInstanceId);
      
      if (!workflowInstanceId) {
        console.log('No workflowInstanceId found for this eForm');
        setRelatedAttachments([]);
        return;
      }
      
      // ?正?????佇????刻麾?蹓潮??踐?貔?寧?????剁?蹓謅??殉死?
      const [mediaFilesResponse, stepExecutionsResponse, messageValidationsResponse] = await Promise.all([
        fetch(`/api/workflowexecutions/${workflowInstanceId}/media-files`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }),
        fetch(`/api/workflowexecutions/${workflowInstanceId}/details`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }),
        fetch(`/api/workflowexecutions/${workflowInstanceId}/message-validations`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
      ]);
      
      // ????佇????刻麾
      let mediaFiles = [];
      if (mediaFilesResponse.ok) {
        const mediaData = await mediaFilesResponse.json();
        mediaFiles = mediaData.data || [];
      } else if (mediaFilesResponse.status !== 404) {
        console.warn('Failed to load media files:', mediaFilesResponse.status);
      }
      
// ????遛?????賤蹓?
let stepExecutions = [];
      if (stepExecutionsResponse.ok) {
        const stepData = await stepExecutionsResponse.json();
        stepExecutions = stepData.stepExecutions || [];
      } else {
        console.warn('Failed to load step executions:', stepExecutionsResponse.status);
      }
      
      // ????剁?蹓謅??殉死?
      let messageValidations = [];
      if (messageValidationsResponse.ok) {
        const validationData = await messageValidationsResponse.json();
        messageValidations = validationData.data || [];
      } else {
        console.warn('Failed to load message validations:', messageValidationsResponse.status);
      }
      
      // ???遛??撥???喲??踐??????蹎?
      const stepIndexToNameMap = {};
      stepExecutions.forEach(step => {
        stepIndexToNameMap[step.stepIndex] = step.stepName || step.stepType || `Step ${step.stepIndex}`;
      });
      
// ???佇??URL??喲??踐???????蹎????謍??剁?蹓謅??殉死???
const mediaUrlToStepIndexMap = {};
      messageValidations.forEach(validation => {
        if (validation.mediaUrl) {
// ????謘踵??綜赯菜??啗??號???
const normalizedUrl = validation.mediaUrl.replace(/\\/g, '/');
          mediaUrlToStepIndexMap[normalizedUrl] = validation.stepIndex;
        }
      });
      
// ?蝞?????????皞?蹎??踐?蝮??
const enrichedMediaFiles = mediaFiles.map(file => {
// ????謘???璆?芾??號???
const normalizedFilePath = file.filePath.replace(/\\/g, '/');
        
        // ?謅疵?綜等?????????????遛??撥?
        let stepIndex = null;
        let stepName = '??堊??遛?';
        
// ?撖?1: ?謍??堆??????璆?恬???
if (mediaUrlToStepIndexMap[normalizedFilePath]) {
          stepIndex = mediaUrlToStepIndexMap[normalizedFilePath];
        } else {
          // ?撖?2: ?謍???刻麾???????????????皝?
          const fileName = file.fileName;
          for (const [url, idx] of Object.entries(mediaUrlToStepIndexMap)) {
            if (url.includes(fileName)) {
              stepIndex = idx;
              break;
            }
          }
        }
        
        // ???????哨??賹??????遛????
        if (stepIndex !== null && stepIndexToNameMap[stepIndex]) {
          stepName = stepIndexToNameMap[stepIndex];
        }
        
        return {
          ...file,
          stepIndex: stepIndex,
          stepName: stepName
        };
      });
      
      console.log('Loaded and enriched media files:', enrichedMediaFiles);
      setRelatedAttachments(enrichedMediaFiles);
    } catch (error) {
      console.error('Failed to load related attachments:', error);
      setRelatedAttachments([]);
    } finally {
      setLoadingAttachments(false);
    }
  };

  const handleExportEmbedFormPdf = async () => {
    const instance = embeddedFormInstance;
    const eform = selectedEform;
    if (!eform?.id || exportingEmbedFormPdf) return;
    const html = instance?.filledHtmlCode || instance?.htmlCode || eform.filledHtmlCode || eform.htmlCode || '';
    const fillType = instance?.fillType || eform.fillType;
    if (!canExportEformToPdf(fillType, html)) {
      message.warning(t('documentLibrary.metaFlowsPdfNotSupported') || 'MetaFlows 表單不支援匯出 PDF');
      return;
    }
    setExportingEmbedFormPdf(true);
    try {
      const token = localStorage.getItem('token');
      const today = TimezoneUtils.formatDateTime(new Date(), 'YYYY-MM-DD');
      const safeName = (eform.formName || `eform_${eform.id}`).replace(/[^\w\-]+/g, '_').slice(0, 80);
      await exportSingleEformInstanceToPdf({
        instanceId: eform.id,
        token,
        fileName: `${safeName}_${today}.pdf`,
      });
      message.success(t('reports.exportSuccess') || '匯出成功');
    } catch (error) {
      if (error.message === 'META_FLOWS_NOT_SUPPORTED') {
        message.warning(t('documentLibrary.metaFlowsPdfNotSupported') || 'MetaFlows 表單不支援匯出 PDF');
      } else {
        message.error((t('reports.exportFailed') || '匯出失敗') + (error.message ? `: ${error.message}` : ''));
      }
    } finally {
      setExportingEmbedFormPdf(false);
    }
  };

  const handleApprove = (eform) => {
    setSelectedEform(eform);
    setApproveModalVisible(true);
    setApprovalNote('');
  };

  const handleReject = (eform) => {
    setSelectedEform(eform);
    setRejectModalVisible(true);
    setApprovalNote('');
  };

// ??????????
const handleStatusChange = (eform, newStatus) => {
    setStatusChangeTarget({ eform, newStatus });
    setStatusChangeNote(''); // ?? note
    setStatusChangeModalVisible(true);
  };

// ??DOM ????萄謘????綽? HTML?pprove/reject/save ?蹇??殉朴??撖???????選??瞏???  // iframe ????WorkflowMonitorPage ?璇? src/utils/formPreviewIframeUtils.collectFilledHtmlFromIframe??  // ??謓?iframe ??fallback ??.form-content-inner ?皝????????React ????????
const collectFilledHtmlFromForm = () => {
    const iframeHtml = collectFilledHtmlFromIframe(embedFormIframeRef);
    if (iframeHtml != null) return iframeHtml;
    const formContainer = document.querySelector('.form-content-inner');
    if (!formContainer) return null;
    const clonedContainer = formContainer.cloneNode(true);
    const origInputs = formContainer.querySelectorAll(FORM_INPUT_SELECTOR);
    const cloneInputs = clonedContainer.querySelectorAll(FORM_INPUT_SELECTOR);
    origInputs.forEach((input, i) => {
      if (cloneInputs[i] && input.value) cloneInputs[i].setAttribute('value', input.value);
    });
    const origTextareas = formContainer.querySelectorAll('textarea');
    const cloneTextareas = clonedContainer.querySelectorAll('textarea');
    origTextareas.forEach((ta, i) => {
      if (cloneTextareas[i] && ta.value) cloneTextareas[i].textContent = ta.value;
    });
    const origSelects = formContainer.querySelectorAll('select');
    const cloneSelects = clonedContainer.querySelectorAll('select');
    origSelects.forEach((select, i) => {
      if (cloneSelects[i]) {
        const opt = select.options[select.selectedIndex];
        if (opt) {
          Array.from(cloneSelects[i].options).forEach(o => o.removeAttribute('selected'));
          const cloneOpt = cloneSelects[i].options[select.selectedIndex];
          if (cloneOpt) cloneOpt.setAttribute('selected', 'selected');
        }
      }
    });
    const origCheckboxes = formContainer.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    const cloneCheckboxes = clonedContainer.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    origCheckboxes.forEach((cb, i) => {
      if (cloneCheckboxes[i]) {
        if (cb.checked) cloneCheckboxes[i].setAttribute('checked', 'checked');
        else cloneCheckboxes[i].removeAttribute('checked');
      }
    });
    return clonedContainer.innerHTML;
  };

  const handleConfirmApprove = async () => {
    if (!selectedEform) return;
    const formContainer = embedFormIframeRef.current?.contentDocument?.body
      || document.querySelector('.embedded-form-modal .form-content-inner')
      || document.querySelector('.ant-modal-open .form-content-inner');
    if (formContainer) {
      const validation = validateEFormRequiredFields(formContainer);
      if (!validation.valid) {
        const keyMap = { fill: 'Fill', upload: 'Upload', check: 'Check', select: 'Select' };
        const msg = validation.fieldLabel
          ? t(`eformValidation.please${keyMap[validation.messageType] || 'Fill'}Field`, { field: validation.fieldLabel })
          : t('eformValidation.pleaseFillRequiredFields');
        message.error(msg);
        throw new Error('validation');
      }
    }
    await processApproval('approve');
  };

  const handleConfirmReject = async () => {
    if (!selectedEform) return;
    if (!(approvalNote || '').trim()) {
      message.error(t('pendingTasks.rejectionReasonRequired'));
      throw new Error('validation');
    }
    await processApproval('reject');
  };

  const processApproval = async (action) => {
    if (!selectedEform) return;

    setProcessingEform(selectedEform.id);
    try {
      console.log(`Processing ${action} operation, form ID: ${selectedEform.id}`);
      const filledHtmlCode = collectFilledHtmlFromForm();

      const response = await fetch(`/api/eforminstances/${selectedEform.id}/${action}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          note: approvalNote,
          approvedBy: getCurrentUsername(),
          filledHtmlCode: filledHtmlCode || undefined
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Operation failed' }));
        throw new Error(errorData.error || `${action} operation failed`);
      }

      const result = await response.json();
      console.log(`${action} operation result:`, result);

      message.success(result.message || t(`pendingTasks.${action === 'approve' ? 'approveSuccess' : 'rejectSuccess'}`));

      // Reload data
      await Promise.all([
        loadAllTabData(),
        loadStatistics(),
        loadFillTypeStatistics()
      ]);

      // Close modals (including embedded form if open)
      setApproveModalVisible(false);
      setRejectModalVisible(false);
      handleCloseEmbeddedForm();
      setSelectedEform(null);
      setApprovalNote('');
    } catch (error) {
      console.error(`${action} operation failed:`, error);
      message.error(t(`pendingTasks.${action === 'approve' ? 'approveFailed' : 'rejectFailed'}`) + ': ' + error.message);
    } finally {
      setProcessingEform(null);
    }
  };

// ????殉此??獢?望撠?????皜???蹓??蟡?撖?????approve/reject ?璇? collectFilledHtmlFromForm??
const saveFormContent = async () => {
    if (!embeddedFormInstance?.id) return;
    setSavingFormContent(true);
    try {
      const filledHtmlCode = collectFilledHtmlFromForm();
      const response = await fetch(`/api/eforminstances/${embeddedFormInstance.id}/save`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ filledHtmlCode: filledHtmlCode || undefined })
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || 'Save failed');
      }
      const result = await response.json();
      message.success(result.message || t('pendingTasks.saveSuccess') || 'Saved successfully');
      setEmbeddedFormInstance(prev => prev ? { ...prev, filledHtmlCode: filledHtmlCode || prev.filledHtmlCode } : null);
      await loadAllTabData();
    } catch (error) {
      console.error('Save form content failed:', error);
      message.error((t('pendingTasks.saveFailed') || '?踐???剜??') + ': ' + error.message);
    } finally {
      setSavingFormContent(false);
    }
  };

// ????萄謘??摹 - ?輯撒????API ??摹?萄謘????擗??踝???
const handleSubmitForm = async () => {
    try {

// ??DOM ????謘潑菜??????獢?望?
const formContainer = document.querySelector('.form-content-inner');
      if (!formContainer) {
        console.error('??????獢???.form-content-inner');
        message.error('???????萄謘??寞?');
        return;
      }

      // ?踐???對?萇???
      const validation = validateEFormRequiredFields(formContainer);
      if (!validation.valid) {
        const keyMap = { fill: 'Fill', upload: 'Upload', check: 'Check', select: 'Select' };
        const msg = validation.fieldLabel
          ? t(`eformValidation.please${keyMap[validation.messageType] || 'Fill'}Field`, { field: validation.fieldLabel })
          : t('eformValidation.pleaseFillRequiredFields');
        message.error(msg);
        validation.firstInvalidEl?.focus?.();
        validation.firstInvalidEl?.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
        return;
      }

      // ????啣音謒?隞遴????摮???DOM
      const clonedContainer = formContainer.cloneNode(true);
      
      // ???????色?獢??????恃?????鈭??瞉???value ?????????選??蹓澗??賹????
      const inputs = clonedContainer.querySelectorAll(FORM_INPUT_SELECTOR);
      inputs.forEach(input => {
        if (input.value) {
          input.setAttribute('value', input.value);
        }
      });

      const selects = clonedContainer.querySelectorAll('select');
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption) {
          selectedOption.setAttribute('selected', 'selected');
        }
      });

      const checkboxes = clonedContainer.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
          checkbox.setAttribute('checked', 'checked');
        }
      });

      const radios = clonedContainer.querySelectorAll('input[type="radio"]');
      radios.forEach(radio => {
        if (radio.checked) {
          radio.setAttribute('checked', 'checked');
        }
      });

      const textareas = clonedContainer.querySelectorAll('textarea');
      textareas.forEach(textarea => {
        textarea.setAttribute('value', textarea.value);
        textarea.textContent = textarea.value;
      });

      const filledHtml = clonedContainer.innerHTML;
      console.log('?□???摹?萄謘??燜ML ??撞:', filledHtml.length);
      
      // ?輯撒????API ??摹?萄謘?鞊????????token??      console.log('??摹 URL:', `/api/eforminstances/${embeddedFormInstance.id}/submit`);
      const response = await fetch(`/api/eforminstances/${embeddedFormInstance.id}/submit`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          filledHtmlCode: filledHtml,
          submittedBy: getCurrentUsername()
        })
      });

      console.log('API ?豯?????', response.status);
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: '??摹?剜??' }));
        console.error('??摹?剜???????', errorData);
        throw new Error(errorData.error || '??摹?剜??');
      }

      const result = await response.json();
      console.log('?萄謘??摹???????', result);
      
      message.success(result.message || '?萄謘??摹???');
      
      // ??????鞊?
      await Promise.all([
        loadAllTabData(),
        loadStatistics(),
        loadFillTypeStatistics()
      ]);
      
      // ?謚?????      handleCloseEmbeddedForm();
      
    } catch (error) {
      console.error('?萄謘??摹?剜??:', error);
      message.error('?萄謘??摹?剜??: ' + error.message);
    }
  };

// ?????????謜??
const processStatusChange = async () => {
    if (!statusChangeTarget) return;

    const { eform, newStatus } = statusChangeTarget;
    setProcessingEform(eform.id);
    
    try {
      console.log(`Changing status from ${eform.status} to ${newStatus}, form ID: ${eform.id}`);
      console.log(`User note: ${statusChangeNote}`);
      
      const filledHtmlCode = collectFilledHtmlFromForm();
      const response = await fetch(`/api/eforminstances/${eform.id}/${newStatus === 'Approved' ? 'approve' : 'reject'}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          note: statusChangeNote || `????? ${eform.status} ?皝???${newStatus}`,
          approvedBy: getCurrentUsername(),
          filledHtmlCode: filledHtmlCode || undefined
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Status change failed' }));
        throw new Error(errorData.error || 'Status change failed');
      }

      const result = await response.json();
      console.log('Status change result:', result);
      
      message.success(result.message || `??????皝???${newStatus}`);
      
      // Reload data
      await Promise.all([
        loadAllTabData(),
        loadStatistics(),
        loadFillTypeStatistics()
      ]);
      
      // Close modal
      setStatusChangeModalVisible(false);
      setStatusChangeTarget(null);
      setStatusChangeNote('');
    } catch (error) {
      console.error('Status change failed:', error);
      message.error('??????摮萎??? ' + error.message);
    } finally {
      setProcessingEform(null);
    }
  };

  // ??賃?/?謘???賃??賹?
  const handleSelectAll = () => {
    const canSelect = (viewMode === 'normal' && activeTab === 'pending') || 
                     (viewMode === 'normal' && activeTab === 'approved') || 
                     (viewMode === 'normal' && activeTab === 'rejected');
    
    if (!canSelect) return;
    
    // ???????蹓遴????????鞊???梱?
    let currentPageData = [];
    if (viewMode === 'normal') {
      switch (activeTab) {
        case 'pending':
          currentPageData = pendingEforms;
          break;
        case 'approved':
          currentPageData = approvedEforms;
          break;
        case 'rejected':
          currentPageData = rejectedEforms;
          break;
        default:
          currentPageData = [];
      }
    }
    
    // ?潘撓貔??秋?????賃?
    const allSelected = currentPageData.every(item => selectedRowKeys.includes(item.id));
    
    if (allSelected) {
// ?謘???賃??垓摰??止????嚗????????
const currentPageIds = currentPageData.map(item => item.id);
      setSelectedRowKeys(prev => prev.filter(key => !currentPageIds.includes(key)));
      setSelectedRows(prev => prev.filter(row => !currentPageIds.includes(row.id)));
    } else {
// ??賃??垮皞?蹎????嚗????????
const newSelectedKeys = [...new Set([...selectedRowKeys, ...currentPageData.map(item => item.id)])];
      const newSelectedRows = [...new Set([...selectedRows, ...currentPageData])];
      setSelectedRowKeys(newSelectedKeys);
      setSelectedRows(newSelectedRows);
    }
  };

  // ?撖?????鞈?
  const handleBatchAction = (action) => {
    setBatchAction(action);
    setBatchNote('');
    setBatchProcessingModalVisible(true);
  };

  const processBatchAction = async () => {
    if (selectedRows.length === 0) return;

    setProcessingBatch(true);
    try {
      console.log(`Processing batch ${batchAction} for ${selectedRows.length} items`);
      
      const promises = selectedRows.map(async (row) => {
        let endpoint, actionText;
        
        switch (batchAction) {
          case 'approve':
            endpoint = `/api/eforminstances/${row.id}/approve`;
            actionText = '?摮?';
            break;
          case 'reject':
            endpoint = `/api/eforminstances/${row.id}/reject`;
            actionText = '???';
            break;
          case 'changeToApproved':
            endpoint = `/api/eforminstances/${row.id}/approve`;
            actionText = '?撖抆冪?摮?';
            break;
          case 'changeToRejected':
            endpoint = `/api/eforminstances/${row.id}/reject`;
            actionText = '?撖抆冪???';
            break;
          default:
            throw new Error('Invalid batch action');
        }

        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            note: batchNote || `?撖?${actionText}`,
            approvedBy: getCurrentUsername()
          })
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({ error: 'Operation failed' }));
          throw new Error(`?萄謘?${row.formName} ${actionText}?剜??: ${errorData.error || 'Operation failed'}`);
        }

        return await response.json();
      });

      const results = await Promise.all(promises);
      console.log('Batch operation results:', results);
      
      message.success(
        batchAction === 'approve' || batchAction === 'changeToApproved' ? 
        t('pendingTasks.batchApprovalSuccess', { count: selectedRows.length }) :
        t('pendingTasks.batchRejectionSuccess', { count: selectedRows.length })
      );
      
      
      setBatchProcessingModalVisible(false);
      setBatchAction('');
      setBatchNote('');
      setSelectedRowKeys([]);
      setSelectedRows([]);
      
      await Promise.all([
        loadAllTabData(),
        loadStatistics(),
        loadFillTypeStatistics()
      ]);
      
    } catch (error) {
      console.error('Batch operation failed:', error);
      message.error(t('pendingTasks.batchOperationFailed') + ': ' + error.message);
    } finally {
      setProcessingBatch(false);
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'High': return 'red';
      case 'Medium': return 'orange';
      case 'Low': return 'green';
      default: return 'default';
    }
  };

  const getPriorityText = (priority) => {
    switch (priority) {
      case 'High': return t('pendingTasks.high');
      case 'Medium': return t('pendingTasks.medium');
      case 'Low': return t('pendingTasks.low');
      default: return priority;
    }
  };

  const getFillTypeColor = (fillType) => {
    switch (fillType) {
      case 'Manual': return 'blue';
      case 'AI': return 'green';
      case 'Data': return 'purple';
      default: return 'default';
    }
  };

  const getFillTypeText = (fillType) => {
    switch (fillType) {
      case 'Manual': return t('pendingTasks.manualFill');
      case 'AI': return t('pendingTasks.aiFill');
      case 'Data': return t('pendingTasks.dataFill');
      default: return fillType || '-';
    }
  };

  // ?佇????刻麾?鞈??鞈?
  const getFileIcon = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'bmp':
      case 'webp':
      case 'svg':
      case 'tiff':
      case 'ico':
        return <FileImageOutlined style={{ color: '#52c41a' }} />;
      case 'mp4':
      case 'avi':
      case 'mov':
      case 'wmv':
      case 'flv':
      case 'webm':
      case 'mkv':
      case 'm4v':
      case '3gp':
        return <VideoCameraOutlined style={{ color: '#1890ff' }} />;
      case 'mp3':
      case 'wav':
      case 'ogg':
      case 'aac':
      case 'flac':
      case 'm4a':
      case 'wma':
        return <AudioOutlined style={{ color: '#fa8c16' }} />;
      case 'pdf':
        return <FilePdfOutlined style={{ color: '#ff4d4f' }} />;
      case 'doc':
      case 'docx':
        return <FileWordOutlined style={{ color: '#1890ff' }} />;
      case 'xls':
      case 'xlsx':
        return <FileExcelOutlined style={{ color: '#52c41a' }} />;
      case 'ppt':
      case 'pptx':
        return <FilePptOutlined style={{ color: '#fa8c16' }} />;
      case 'txt':
        return <FileTextOutlined style={{ color: '#666' }} />;
      case 'zip':
      case 'rar':
      case '7z':
        return <FileZipOutlined style={{ color: '#722ed1' }} />;
      default:
        return <FileOutlined style={{ color: '#999' }} />;
    }
  };

  const getFileType = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff', 'ico'];
    const videoTypes = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv', 'm4v', '3gp'];
    const audioTypes = ['mp3', 'wav', 'ogg', 'aac', 'flac', 'm4a', 'wma'];
    
    if (imageTypes.includes(extension)) return 'image';
    if (videoTypes.includes(extension)) return 'video';
    if (audioTypes.includes(extension)) return 'audio';
    return 'document';
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  // Lightbox ?鞈??鞈?
  const openLightbox = (file, allFiles = []) => {
    const imageVideoFiles = allFiles.filter(f => {
      const fileType = getFileType(f.fileName);
      return fileType === 'image' || fileType === 'video';
    });
    
    const currentIndex = imageVideoFiles.findIndex(f => f.id === file.id);
    
    setLightboxFiles(imageVideoFiles);
    setLightboxFile(file);
    setLightboxCurrentIndex(currentIndex >= 0 ? currentIndex : 0);
    setLightboxVisible(true);
  };

  const closeLightbox = () => {
    setLightboxVisible(false);
    setLightboxFile(null);
    setLightboxFiles([]);
    setLightboxCurrentIndex(0);
  };

  const goToPrevious = () => {
    if (lightboxFiles.length > 0) {
      const newIndex = lightboxCurrentIndex > 0 ? lightboxCurrentIndex - 1 : lightboxFiles.length - 1;
      setLightboxCurrentIndex(newIndex);
      setLightboxFile(lightboxFiles[newIndex]);
    }
  };

  const goToNext = () => {
    if (lightboxFiles.length > 0) {
      const newIndex = lightboxCurrentIndex < lightboxFiles.length - 1 ? lightboxCurrentIndex + 1 : 0;
      setLightboxCurrentIndex(newIndex);
      setLightboxFile(lightboxFiles[newIndex]);
    }
  };

  const isOverdue = (dueDate) => {
    if (!dueDate) return false;
    return new Date(dueDate) < new Date();
  };

  // ????蛛閬????鞈?
  const getRowStyle = (record) => {
// Form ?殉????PV ?２?????啣音??????
const hasFields = hasExpandableContent(record);
    return {
      cursor: 'pointer',
      minHeight: hasFields ? '45px' : '35px'
    };
  };

  const getStatusTag = (status, dueDate, record = null) => {
// ?撖????????堊契嚗?
let color, text, icon;
    const approvalLabels = getEFormApprovalLabels(record, t, {
      approve: 'pendingTasks.approved',
      reject: 'pendingTasks.rejected',
    });
    
    switch (status) {
      case 'Approved':
        color = 'green';
        text = approvalLabels.approve;
        icon = <CheckCircleOutlined />;
        break;
      case 'Rejected':
        color = 'red';
        text = approvalLabels.reject;
        icon = <CloseCircleOutlined />;
        break;
      case 'Submitted':
        color = 'blue';
        text = t('pendingTasks.submitted');
        icon = <FileTextOutlined />;
        break;
      case 'Pending':
      default:
        // ??謘?Pending ??????潘撓貔??秋????
    const isOverdueStatus = isOverdue(dueDate);
        color = isOverdueStatus ? 'error' : 'warning';
        text = isOverdueStatus ? t('pendingTasks.overdue') : t('pendingTasks.pending');
        icon = <ClockCircleOutlined />;
        break;
    }
    
    return (
      <Tag color={color} icon={icon}>
        {text}
      </Tag>
    );
  };

// ?????蛛???寞???謘?????orm ?殉????PV ????輯??批?謜??遴???????????????  // - Form ?殉??曉?謍???拚??eader bg=#e6f4ff??order=#91caff??  // - ?播???? (PV)?垓???拚??eader bg=#f9f0ff??order=#d3adf7??  // - fieldDisplaySettings / pvDisplaySettings ????? order ????? form ????蹍肖 ???????  //   ?嚗??謕???曇澈?堊垓???????砍????? Form ??PV????皝??止等???  // - ?２??謅??鈭亙眺?????? rowKey??? fieldId / variableName ??JSON Key ???????叟城??蹇??秋????allback ??fieldId / variableName??
const renderExpandedRow = (record) => {
    const visibleFields = Array.isArray(record.fieldDisplaySettings)
      ? record.fieldDisplaySettings
          .filter(f => f.showInList)
          .slice()
          .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
      : [];
    const visiblePvs = Array.isArray(record.pvDisplaySettings)
      ? record.pvDisplaySettings.slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
      : [];

    if (visibleFields.length === 0 && visiblePvs.length === 0) {
      return (
        <div style={{ padding: '16px', textAlign: 'center', color: '#999' }}>
          ????曇???秋撫頨急?        </div>
      );
    }

    const fieldLookupKey = (f) => f.rowKey || (f.jsonKey ? `${f.fieldId}::${f.jsonKey}` : f.fieldId);
    const pvLookupKey = (p) => p.rowKey || (p.jsonKey ? `${p.variableName}::${p.jsonKey}` : p.variableName);

    // ?舀??????爸 key, label, value, kind: 'form' | 'pv' }
    const cells = [
      ...visibleFields.map(f => ({
        key: `form::${fieldLookupKey(f)}`,
        label: f.displayLabel,
        value: record.parsedFieldValues?.[fieldLookupKey(f)],
        kind: 'form'
      })),
      ...visiblePvs.map(p => ({
        key: `pv::${pvLookupKey(p)}`,
        label: p.displayLabel,
        value: record.parsedPvValues?.[pvLookupKey(p)],
        kind: 'pv'
      }))
    ];

// ?遴????奕???Form?蹓賣???PV??
const palette = {
      form: { headerBg: '#e6f4ff', headerBorder: '#91caff', headerText: '#0958d9', valueBg: '#f5faff', valueBorder: '#bae0ff' },
      pv:   { headerBg: '#f9f0ff', headerBorder: '#d3adf7', headerText: '#531dab', valueBg: '#fbf5ff', valueBorder: '#efdbff' }
    };

    return (
      <div style={{ padding: '8px', backgroundColor: '#fafafa' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${cells.length}, minmax(80px, 1fr))`,
          gap: '4px',
          backgroundColor: '#fff',
          borderRadius: '4px',
          padding: '6px',
          border: '1px solid #e8e8e8'
        }}>
          {cells.map(c => {
            const p = palette[c.kind];
            return (
              <div key={`header-${c.key}`} style={{
                fontWeight: 600,
                color: p.headerText,
                fontSize: '12px',
                padding: '4px',
                backgroundColor: p.headerBg,
                borderRadius: '3px',
                textAlign: 'center',
                border: `1px solid ${p.headerBorder}`
              }}>
                {c.label}
              </div>
            );
          })}
          {cells.map(c => {
            const p = palette[c.kind];
            return (
              <div key={`value-${c.key}`} style={{
                color: '#333',
                fontSize: '12px',
                padding: '4px',
                backgroundColor: p.valueBg,
                borderRadius: '3px',
                textAlign: 'center',
                border: `1px solid ${p.valueBorder}`,
                minHeight: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {c.value || '-'}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  // columns ???????拍??刻正???- ?輯撒??useMemo ?撖? activeTab ????殷??
  const baseColumns = React.useMemo(() => [
    // Column: select all
    {
      title: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Button
            type="text"
            size="small"
            icon={(() => {
              const currentEforms = getCurrentEforms();
              const expandableKeys = currentEforms
                .filter(hasExpandableContent)
                .map(record => record.id);
              const allExpanded = expandableKeys.length > 0 && expandableKeys.every(key => expandedRowKeys.includes(key));
              return allExpanded ? <MinusOutlined /> : <PlusOutlined />;
            })()}
            onClick={handleToggleExpandAll}
            title="??賂豢???/???"
            style={{ padding: '2px 6px', fontSize: '12px' }}
          />
          <input
            type="checkbox"
            checked={(() => {
              const canSelect = (viewMode === 'normal' && activeTab === 'pending') || 
                               (viewMode === 'normal' && activeTab === 'approved') || 
                               (viewMode === 'normal' && activeTab === 'rejected');
              
              if (!canSelect) return false;
              
// ???????蹓遴?????
let currentPageData = [];
              if (viewMode === 'normal') {
                switch (activeTab) {
                  case 'pending':
                    currentPageData = pendingEforms;
                    break;
                  case 'approved':
                    currentPageData = approvedEforms;
                    break;
                  case 'rejected':
                    currentPageData = rejectedEforms;
                    break;
                  default:
                    currentPageData = [];
                }
              }
              
              // ?潘撓貔??秋???賃????????嚗?????獢??⊥?蹓???
              return currentPageData.length > 0 && currentPageData.every(item => selectedRowKeys.includes(item.id));
            })()}
            onChange={handleSelectAll}
            style={{ cursor: 'pointer' }}
            title={(() => {
              const canSelect = (viewMode === 'normal' && activeTab === 'pending') || 
                               (viewMode === 'normal' && activeTab === 'approved') || 
                               (viewMode === 'normal' && activeTab === 'rejected');
              
              if (!canSelect) return '';
              
// ???????蹓遴?????
let currentPageData = [];
              if (viewMode === 'normal') {
                switch (activeTab) {
                  case 'pending':
                    currentPageData = pendingEforms;
                    break;
                  case 'approved':
                    currentPageData = approvedEforms;
                    break;
                  case 'rejected':
                    currentPageData = rejectedEforms;
                    break;
                  default:
                    currentPageData = [];
                }
              }
              
              const allSelected = currentPageData.length > 0 && currentPageData.every(item => selectedRowKeys.includes(item.id));
              return allSelected ? t('pendingTasks.deselectAll') : t('pendingTasks.selectAll');
            })()}
          />
          {selectedRowKeys.length > 0 && (
            <Tag color="blue" style={{ fontSize: '10px', margin: 0 }}>
              {selectedRowKeys.length}
            </Tag>
          )}
        </div>
      ),
      key: 'selection',
      width: 80,
      fixed: 'left',
      render: (_, record) => {
// ?撖??秋□?????????????秋??輯???鞊???
const canSelect = (viewMode === 'normal' && activeTab === 'pending') || 
                         (viewMode === 'normal' && activeTab === 'approved') || 
                         (viewMode === 'normal' && activeTab === 'rejected');
        
        if (!canSelect) return null;
        
        return (
          <input
            type="checkbox"
            checked={selectedRowKeys.includes(record.id)}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedRowKeys(prev => [...prev, record.id]);
                setSelectedRows(prev => [...prev, record]);
              } else {
                setSelectedRowKeys(prev => prev.filter(key => key !== record.id));
                setSelectedRows(prev => prev.filter(row => row.id !== record.id));
              }
            }}
            style={{ cursor: 'pointer' }}
          />
        );
      }
    },
    {
      title: t('pendingTasks.processInstanceId'),
      dataIndex: 'workflowInstanceId',
      key: 'workflowInstanceId',
      width: 130,
      fixed: 'left',
      sorter: (a, b) => (a.workflowInstanceId ?? 0) - (b.workflowInstanceId ?? 0),
      sortDirections: ['ascend', 'descend'],
      render: (id) => (
        <Text code style={{ fontSize: '12px' }}>{id != null && id !== '' ? String(id) : '-'}</Text>
      )
    },
    {
      title: t('pendingTasks.formName'),
      dataIndex: 'formName',
      key: 'formName',
      width: 200,
      sorter: (a, b) => a.formName.localeCompare(b.formName),
      sortDirections: ['ascend', 'descend'],
      render: (text, record) => (
        <div>
          <Text strong style={{ fontSize: '14px' }}>{text}</Text>
          <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>
            {record.instanceName}
          </div>
        </div>
      )
    },
    {
      title: t('pendingTasks.status'),
      dataIndex: 'status',
      key: 'status',
      width: 120,
      sorter: (a, b) => {
        const getStatusValue = (record) => {
          if (isOverdue(record.dueDate)) return 0; // Overdue first
          return 1; // Pending
        };
        return getStatusValue(a) - getStatusValue(b);
      },
      sortDirections: ['ascend', 'descend'],
      render: (status, record) => getStatusTag(status, record.dueDate, record)
    },
    {
      title: t('pendingTasks.fillType'),
      dataIndex: 'fillType',
      key: 'fillType',
      width: 120,
      sorter: (a, b) => a.fillType?.localeCompare(b.fillType || ''),
      sortDirections: ['ascend', 'descend'],
      render: (fillType, record) => (
        <Tag color={getFillTypeColor(fillType)}>
          {getFillTypeText(fillType)}
        </Tag>
      )
    },
    {
      title: t('pendingTasks.applicant'),
      dataIndex: 'createdBy',
      key: 'createdBy',
      width: 120,
      sorter: (a, b) => a.createdBy.localeCompare(b.createdBy),
      sortDirections: ['ascend', 'descend'],
      render: (text, record) => (
        <Space>
          <UserOutlined />
          {text}
        </Space>
      )
    },
    {
      title: t('common.userMessage'),
      dataIndex: 'userMessage',
      key: 'userMessage',
      width: 200,
      render: (text) => {
        const result = extractAiAnalysisResult(text);
        // ????荒????荒? HTML ?????寡???dangerouslySetInnerHTML
        if (typeof result === 'string' && result.includes('<table')) {
          return (
            <Tooltip title={<div dangerouslySetInnerHTML={{ __html: result }} />} placement="topLeft">
              <div 
                style={{ 
                  fontSize: '12px', 
                  color: '#333',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  wordBreak: 'break-word',
                  lineHeight: '1.4',
                  maxHeight: '2.8em'
                }} 
                dangerouslySetInnerHTML={{ __html: result }} 
              />
            </Tooltip>
          );
        }
        const displayText = result || '-';
        return (
          <Tooltip title={displayText} placement="topLeft">
            <div 
              style={{ 
                fontSize: '12px', 
                color: '#333',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                wordBreak: 'break-word',
                lineHeight: '1.4',
                maxHeight: '2.8em'
              }}
            >
              {displayText}
            </div>
          </Tooltip>
        );
      }
    },
    {
      title: t('common.recipientName'),
      dataIndex: 'recipientName',
      key: 'recipientName',
      width: 150,
      render: (text) => (
        <div style={{ fontSize: '12px', color: '#333' }}>
          {text || '-'}
        </div>
      )
    },
    {
      title: t('common.recipientWhatsApp'),
      dataIndex: 'recipientWhatsAppNo',
      key: 'recipientWhatsAppNo',
      width: 150,
      render: (text) => (
        <div style={{ fontSize: '12px', color: '#333' }}>
          {text || '-'}
        </div>
      )
    },
    {
      title: t('common.createdAt'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 150,
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      sortDirections: ['ascend', 'descend'],
      render: (text) => (
        <div style={{ fontSize: '12px', color: '#333' }}>
          {text ? TimezoneUtils.formatDateWithTimezone(text, userTimezoneOffset, 'MM-DD HH:mm') : '-'}
        </div>
      )
    },
    {
      title: t('common.updatedAt'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 150,
      sorter: (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt),
      sortDirections: ['ascend', 'descend'],
      render: (text) => (
        <div style={{ fontSize: '12px', color: '#333' }}>
          {text ? TimezoneUtils.formatDateWithTimezone(text, userTimezoneOffset, 'MM-DD HH:mm') : '-'}
        </div>
      )
    },
    {
      title: activeTab === 'approved' ? t('pendingTasks.approvedBy') : activeTab === 'rejected' ? t('pendingTasks.rejectedBy') : '',
      dataIndex: activeTab === 'approved' ? 'approvalBy' : activeTab === 'rejected' ? 'rejectedBy' : '',
      key: activeTab === 'approved' ? 'approvalBy' : activeTab === 'rejected' ? 'rejectedBy' : '',
      width: 150,
      render: (text, record) => {
        if (activeTab === 'approved') {
          return (
            <Space size="small">
              <UserOutlined />
              <Text>{record.approvalBy || '-'}</Text>
            </Space>
          );
        } else if (activeTab === 'rejected') {
          return (
            <Space size="small">
              <UserOutlined />
              <Text>{record.rejectedBy || '-'}</Text>
            </Space>
          );
        }
        return null;
      }
    },
    {
      title: t('pendingTasks.action'),
      key: 'action',
      width: 180,
      fixed: 'right',
       render: (_, record) => {
// Manual Fill ????嚗蝞??遴???遴鬥???
if (viewMode === 'manual') {
           return null;
         }
// Normal ??????????萄謘????瑞???鳴????????荒??????         else
if (viewMode === 'normal' && activeTab === 'pending') {
           const approvalLabels = getEFormApprovalLabels(record, t);
           return (
        <Space size="small">
          <Tooltip title={approvalLabels.approve}>
            <Button 
              type="primary"
              icon={<CheckCircleOutlined />} 
              onClick={(e) => {
                e.stopPropagation(); // Prevent row click event
                handleApprove(record);
              }}
              style={{ 
                backgroundColor: '#52c41a',
                borderColor: '#52c41a',
                minWidth: '60px',
                height: '32px'
              }}
              size="small"
            >
              {approvalLabels.approve}
            </Button>
          </Tooltip>
          
          <Tooltip title={approvalLabels.reject}>
            <Button 
              type="primary"
              danger
              icon={<CloseCircleOutlined />} 
              onClick={(e) => {
                e.stopPropagation(); // Prevent row click event
                handleReject(record);
              }}
              style={{ 
                minWidth: '60px',
                height: '32px'
              }}
              size="small"
            >
              {approvalLabels.reject}
            </Button>
          </Tooltip>
        </Space>
           );
         } else if (activeTab === 'approved') {
           return (
             <Space size="small">
               <Button 
                 type="primary"
                 danger
                 size="small"
                 onClick={(e) => {
                   e.stopPropagation();
                   handleStatusChange(record, 'Rejected');
                 }}
                 style={{ minWidth: '120px' }}
               >
                 {t('pendingTasks.changeToRejected')}
               </Button>
             </Space>
           );
         } else if (activeTab === 'rejected') {
           return (
             <Space size="small">
               <Button 
                 type="primary"
                 size="small"
                 onClick={(e) => {
                   e.stopPropagation();
                   handleStatusChange(record, 'Approved');
                 }}
                 style={{ 
                   backgroundColor: '#52c41a',
                   borderColor: '#52c41a',
                   minWidth: '120px'
                 }}
               >
                 {t('pendingTasks.changeToApproved')}
               </Button>
             </Space>
           );
         } else {
           return (
             <Space size="small">
               <Text type="secondary">
                 {activeTab === 'approved' ? t('pendingTasks.approvedBy') : t('pendingTasks.rejectedBy')}
               </Text>
             </Space>
           );
         }
       }
    }
  ], [activeTab, viewMode, t, selectedRowKeys, expandedRowKeys, pendingEforms, approvedEforms, rejectedEforms, manualPendingEforms, manualRespondedEforms, userTimezoneOffset]);

  const [columnWidths, setColumnWidths] = useState({});
  
// ???????
const [paginationStates, setPaginationStates] = useState({
    manualPending: { current: 1, pageSize: 50 },
    manualResponded: { current: 1, pageSize: 50 },
    pending: { current: 1, pageSize: 50 },
    approved: { current: 1, pageSize: 50 },
    rejected: { current: 1, pageSize: 50 }
  });

  const resizableColumns = React.useMemo(() => 
    baseColumns.map(col => ({ 
      ...col, 
      width: columnWidths[col.key] || col.width || 120 
    }))
  , [baseColumns, columnWidths]);

// ???????鞈? - ?皝??蹓遴??蹇????????
const handlePaginationChange = (tabKey) => async (page, pageSize) => {
    setPaginationStates(prev => ({
      ...prev,
      [tabKey]: { current: page, pageSize }
    }));
    
// ?撖? tabKey ?方撒???????????
if (viewMode === 'manual') {
      if (tabKey === 'manualPending') {
        await loadManualPendingEforms();
      } else if (tabKey === 'manualResponded') {
        await loadManualRespondedEforms();
      }
    } else {
      if (tabKey === 'pending') {
        await loadPendingEforms();
      } else if (tabKey === 'approved') {
        await loadApprovedEforms();
      } else if (tabKey === 'rejected') {
        await loadRejectedEforms();
      }
    }
  };

  const handlePageSizeChange = (tabKey) => async (current, size) => {
    setPaginationStates(prev => ({
      ...prev,
      [tabKey]: { current: 1, pageSize: size }
    }));
    
// ?撖? tabKey ?方撒???????????
if (viewMode === 'manual') {
      if (tabKey === 'manualPending') {
        await loadManualPendingEforms();
      } else if (tabKey === 'manualResponded') {
        await loadManualRespondedEforms();
      }
    } else {
      if (tabKey === 'pending') {
        await loadPendingEforms();
      } else if (tabKey === 'approved') {
        await loadApprovedEforms();
      } else if (tabKey === 'rejected') {
        await loadRejectedEforms();
      }
    }
  };

// ???????綽??鞊? - ??祗?鞊????綽?????蹎??謆?鈭???
const getPaginatedData = (data, tabKey) => {
// ?鞊????綽?????蹎??謆?鈭??豯???止??
return data;
  };

  const handleResize = index => (e, { size }) => {
    const column = resizableColumns[index];
    setColumnWidths(prev => ({
      ...prev,
      [column.key]: size.width
    }));
  };

  const mergedColumns = resizableColumns.map((col, index) => ({
    ...col,
    onHeaderCell: column => ({
      width: col.width,
      onResize: handleResize(index),
    }),
  }));

  const components = {
    header: {
      cell: ResizableTitle,
    },
  };


  return (
    <Layout style={{ height: '100vh', background: '#f0f2f5' }}>
      {/* ?謘? AntD ??貉? fixed ????瞏???expanded row ??sticky ?蛛蹌剖???????寞???????????殷??*/}
      <style>{`
        .pending-tasks-page .ant-table-expanded-row > .ant-table-cell {
          position: static !important;
          width: auto !important;
        }
        .pending-tasks-page .ant-table-expanded-row > .ant-table-cell > * {
          position: static !important;
        }
      `}</style>
      <Content className="pending-tasks-page" style={{ 
        padding: '16px', 
        display: 'flex', 
        flexDirection: 'column', 
        height: '100vh',
        overflow: 'hidden'
      }}>
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column',
          gap: '12px',
          flex: 1,
          overflow: 'hidden',
          minHeight: 0
        }}>
          {/* Smart Buttons */}
          <div style={{ flexShrink: 0 }}>
            <div style={{ 
              display: 'flex', 
              gap: '12px',
              width: '100%',
              marginBottom: '3px'
            }}>
              {/* In-house Form Smart Button */}
              <Card 
                size="small" 
                hoverable
                onClick={() => setViewMode('normal')}
                style={{ 
                  flex: '1',
                  cursor: 'pointer',
                  border: viewMode === 'normal' ? '2px solid #52c41a' : '1px solid #d9d9d9',
                  backgroundColor: viewMode === 'normal' ? '#f6ffed' : '#fff'
                }}
                styles={{ body: { padding: '16px' } }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', height: '100%' }}>
                  {/* ??蹓?謍??選??方? */}
                  <div style={{ flex: 1 }}>
                    <div style={{ 
                      fontSize: '16px', 
                      fontWeight: '600', 
                      marginBottom: '2px',
                      color: '#52c41a'
                    }}>
                      {t('pendingTasks.inhouseForm')}
                    </div>
                    <div style={{ 
                      fontSize: '10px', 
                      color: '#666', 
                      lineHeight: '1.2'
                    }}
                    dangerouslySetInnerHTML={{ __html: t('pendingTasks.inhouseFormDescription') }}
                    />
                  </div>
                  
                  {/* ??啾??帑I ??Data ?殷???*/}
                  <div style={{ display: 'flex', gap: '12px' }}>
                    <div style={{ textAlign: 'center' }}>
                      <RobotOutlined style={{ fontSize: '20px', color: '#52c41a', marginBottom: '2px' }} />
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#52c41a' }}>
                        {fillTypeStatistics.aiFillCount}
                      </div>
                      <div style={{ fontSize: '10px', color: '#666' }}>AI</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <DatabaseOutlined style={{ fontSize: '20px', color: '#722ed1', marginBottom: '2px' }} />
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#722ed1' }}>
                        {fillTypeStatistics.dataFillCount}
                      </div>
                      <div style={{ fontSize: '10px', color: '#666' }}>Data</div>
                    </div>
                  </div>
                </div>
              </Card>

              {/* Public Form Smart Button */}
              <Card 
                size="small" 
                hoverable
                onClick={() => setViewMode('manual')}
                style={{ 
                  flex: '1',
                  cursor: 'pointer',
                  border: viewMode === 'manual' ? '2px solid #1890ff' : '1px solid #d9d9d9',
                  backgroundColor: viewMode === 'manual' ? '#f0f8ff' : '#fff'
                }}
                styles={{ body: { padding: '16px' } }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', height: '100%' }}>
                  {/* ??蹓?謍??選??方? */}
                  <div style={{ flex: 1 }}>
                    <div style={{ 
                      fontSize: '16px', 
                      fontWeight: '600', 
                      marginBottom: '2px',
                      color: '#1890ff'
                    }}>
                      {t('pendingTasks.publicForm')}
                    </div>
                    <div style={{ 
                      fontSize: '10px', 
                      color: '#666', 
                      lineHeight: '1.2'
                    }}
                    dangerouslySetInnerHTML={{ __html: t('pendingTasks.publicFormDescription') }}
                    />
                  </div>
                  
                  {/* ??啾??征anual Fill ?殷???*/}
                  <div style={{ textAlign: 'center' }}>
                    <FormOutlined style={{ fontSize: '24px', color: '#1890ff', marginBottom: '4px' }} />
                    <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#1890ff' }}>
                      {fillTypeStatistics.manualFillCount}
                    </div>
                    <div style={{ fontSize: '10px', color: '#666' }}>Manual</div>
                  </div>
                </div>
              </Card>

              {/* Summary Statistics */}
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(4, 1fr)', 
                gap: '8px',
                flex: '2'
              }}>
                <Card size="small" styles={{ body: { padding: '12px' } }}>
                  <Statistic
                    title={t('pendingTasks.approvedForms')}
                    value={counts.approved}
                    prefix={<CheckCircleOutlined />}
                    valueStyle={{ color: '#52c41a', fontSize: '16px' }}
                  />
                </Card>
                
                <Card size="small" styles={{ body: { padding: '12px' } }}>
                  <Statistic
                    title={t('pendingTasks.pendingForms')}
                    value={counts.pending}
                    prefix={<ClockCircleOutlined />}
                    valueStyle={{ color: '#faad14', fontSize: '16px' }}
                  />
                </Card>
                
                <Card size="small" styles={{ body: { padding: '12px' } }}>
                  <Statistic
                    title={t('pendingTasks.rejectedForms')}
                    value={counts.rejected}
                    prefix={<CloseCircleOutlined />}
                    valueStyle={{ color: '#ff4d4f', fontSize: '16px' }}
                  />
                </Card>
                
                <Card size="small" styles={{ body: { padding: '12px' } }}>
                  <Statistic
                    title={t('pendingTasks.overdueItems')}
                    value={statistics.overdue}
                    prefix={<ExclamationCircleOutlined />}
                    valueStyle={{ color: '#ff4d4f', fontSize: '16px' }}
                  />
                </Card>
              </div>
            </div>
          </div>

          {/* Filter and Search */}
          <div style={{ flexShrink: 0 }}>
            <Card size="small" styles={{ body: { padding: '12px' } }}>
            <DefinitionCategoryTabs
              iconType="form"
              allLabel={t('pendingTasks.all')}
              allValue="all"
              value={filters.definition}
              allCount={definitionCounts.total}
              items={definitionTabItems}
              loading={loadingDefinitionCounts}
              onChange={handleDefinitionFilter}
            />
            <Row gutter={[8, 8]} align="middle" wrap={false} style={{ flexWrap: 'nowrap', marginTop: 4 }}>
              <Col flex="auto">
                <Search
                  placeholder={t('pendingTasks.searchPlaceholder')}
                  value={filters.searchText}
                  onChange={(e) => setFilters(prev => ({ ...prev, searchText: e.target.value }))}
                  onSearch={handleSearch}
                  style={{ width: '100%' }}
                />
              </Col>
              
              <Col flex="240px">
                <RangePicker
                  placeholder={['Create date from', 'Create date to']}
                  value={filters.dateRange}
                  onChange={handleDateRangeChange}
                  style={{ width: '100%' }}
                />
              </Col>
              
              <Col flex="none">
                <Button
                  icon={<ClearOutlined />}
                  onClick={handleClearFilters}
                >
                  {t('pendingTasks.clearFilters')}
                </Button>
              </Col>

              <Col flex="none">
                <Button 
                  icon={<ReloadOutlined />} 
                  onClick={loadPendingEforms}
                  loading={loading}
                >
                  {t('pendingTasks.refresh')}
                </Button>
              </Col>

              <Col flex="none">
                <Tooltip
                  title={filters.definition === 'all'
                    ? (t('pendingTasks.exportDisabledTip') || '?ｇ???????抆??獢??????Definition ?????穿 Excel')
                    : ''}
                >
                  <Button
                    icon={<FileExcelOutlined />}
                    onClick={handleExportExcel}
                    disabled={filters.definition === 'all'}
                    loading={exporting}
                    style={filters.definition !== 'all' ? { color: '#217346', borderColor: '#217346' } : {}}
                  >
                    {t('pendingTasks.exportExcel') || 'Export Excel'}
                  </Button>
                </Tooltip>
              </Col>
            </Row>
            </Card>
          </div>

          {/* Batch Operations */}
          {selectedRowKeys.length > 0 && (
            <div style={{ flexShrink: 0 }}>
              <Card size="small" styles={{ body: { padding: '12px' } }}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '12px',
                  justifyContent: 'space-between'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Text strong>{t('pendingTasks.selectedItems', { count: selectedRowKeys.length })}</Text>
                    <Button 
                      size="small" 
                      onClick={() => {
                        setSelectedRowKeys([]);
                        setSelectedRows([]);
                      }}
                    >
                      {t('pendingTasks.clearSelection')}
                    </Button>
                  </div>
                  
                  <div style={{ display: 'flex', gap: '8px' }}>
                    {viewMode === 'normal' && activeTab === 'pending' && (
                      <>
                        <Button 
                          type="primary"
                          icon={<CheckCircleOutlined />}
                          onClick={() => handleBatchAction('approve')}
                          style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                        >
                          {t('pendingTasks.batchApprove')}
                        </Button>
                        <Button 
                          type="primary"
                          danger
                          icon={<CloseCircleOutlined />}
                          onClick={() => handleBatchAction('reject')}
                        >
                          {t('pendingTasks.batchReject')}
                        </Button>
                      </>
                    )}
                    
                    {viewMode === 'normal' && activeTab === 'approved' && (
                      <Button 
                        type="primary"
                        danger
                        icon={<CloseCircleOutlined />}
                        onClick={() => handleBatchAction('changeToRejected')}
                      >
                        {t('pendingTasks.batchChangeToRejected')}
                      </Button>
                    )}
                    
                    {viewMode === 'normal' && activeTab === 'rejected' && (
                      <Button 
                        type="primary"
                        icon={<CheckCircleOutlined />}
                        onClick={() => handleBatchAction('changeToApproved')}
                        style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                      >
                        {t('pendingTasks.batchChangeToApproved')}
                      </Button>
                    )}
                  </div>
                </div>
              </Card>
            </div>
          )}

          {/* Forms List with Tabs */}
          <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <Card 
            size="small"
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden'
            }}
              styles={{
                body: {
                  padding: '0px',
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden'
                }
              }}
            >
              {viewMode === 'normal' && counts.pending > 0 && (
                <style>{`
                  .pending-page-tabs .ant-tabs-tab[data-node-key="pending"] {
                    background-color: #fffbe6 !important;
                    border-radius: 6px 6px 0 0 !important;
                  }
                `}</style>
              )}
              <Tabs
                activeKey={activeTab}
                onChange={handleTabChange}
                className="pending-page-tabs"
                style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column'
                }}
                tabBarStyle={{
                  margin: '0px',
                  padding: '12px 12px 0px 12px'
                }}
                items={viewMode === 'manual' ? [
                  {
                    key: 'pending',
                    label: (
              <Space>
                        <Text>{t('pendingTasks.manualPendingForms')}</Text>
                        <Badge count={counts.manualPending} showZero />
              </Space>
                    ),
                    children: (
                      <div style={{ 
                        flex: 1, 
                        minHeight: 0, 
                        overflow: 'hidden',
                        padding: '12px',
                        display: 'flex',
                        flexDirection: 'column'
                      }}>
                        <Table
                          components={components}
                          columns={mergedColumns}
                          dataSource={getPaginatedData(manualPendingEforms, 'manualPending')}
                          rowKey="id"
                          loading={loading}
                          pagination={false}
                          expandable={{
                            expandedRowKeys: expandedRowKeys,
                            onExpandedRowsChange: setExpandedRowKeys,
                            expandedRowRender: renderExpandedRow,
                            expandRowByClick: false,
                            expandIconColumnIndex: 0,
                            expandIconColumnTitle: () => (
                              <Button
                                type="text"
                                size="small"
                                icon={(() => {
                                  const currentEforms = getCurrentEforms();
                                  const expandableKeys = currentEforms
                                    .filter(hasExpandableContent)
                                    .map(record => record.id);
                                  const allExpanded = expandableKeys.length > 0 && expandableKeys.every(key => expandedRowKeys.includes(key));
                                  return allExpanded ? <MinusOutlined /> : <PlusOutlined />;
                                })()}
                                onClick={handleToggleExpandAll}
                                title="??賂豢???/???"
                                style={{ padding: '2px 6px', fontSize: '12px' }}
                              />
                            ),
                            expandIcon: ({ expanded, onExpand, record }) => {
                              // Form ?殉????PV ?２????????寞??????expand ?謘曉
                              if (!hasExpandableContent(record)) return null;
                              
                              return (
                                <Button
                                  type="text"
                                  size="small"
                                  icon={expanded ? <MinusOutlined /> : <PlusOutlined />}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onExpand(record, e);
                                  }}
                                  style={{ 
                                    width: '20px', 
                                    height: '20px', 
                                    padding: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}
                                />
                              );
                            }
                          }}
                          onRow={(record) => ({
                            onClick: (e) => {
// ????綜等?????鞊??謅??蝞???蹓?謅????怨?謒????萄謘?
if (e.target.closest('td.ant-table-cell-fix-left-last') || 
                                  e.target.closest('th.ant-table-cell-fix-left-last') ||
                                  e.target.closest('td.ant-table-cell-fix-left') ||
                                  e.target.closest('th.ant-table-cell-fix-left')) {
                                return;
                              }
                              handleViewEform(record);
                            },
                            style: getRowStyle(record)
                          })}
                          scroll={{ 
                            x: 1200,
                            y: getTableScrollHeight()
                          }}
                          sticky={{
                            offsetHeader: 0
                          }}
                          locale={{
                            emptyText: (
                              <Empty 
                                description={t('pendingTasks.noManualPendingForms')} 
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                              />
                            )
                          }}
                        />
                        <div style={{ marginTop: 16, textAlign: 'left' }}>
                          <Pagination
                            current={paginationStates.manualPending.current}
                            pageSize={paginationStates.manualPending.pageSize}
                            total={counts.manualPending}
                            showSizeChanger
                            showQuickJumper
                            pageSizeOptions={['10', '20', '50', '100']}
                            showTotal={(total, range) => 
                              t('pendingTasks.pageRange', { start: range[0], end: range[1], total })
                            }
                            onChange={handlePaginationChange('manualPending')}
                            onShowSizeChange={handlePageSizeChange('manualPending')}
                          />
                        </div>
            </div>
                    )
                  },
                  {
                    key: 'responded',
                    label: (
                      <Space>
                        <Text>{t('pendingTasks.manualRespondedForms')}</Text>
                        <Badge count={counts.manualResponded} showZero />
                      </Space>
                    ),
                    children: (
                      <div style={{ 
                        flex: 1, 
                        minHeight: 0, 
                        overflow: 'hidden',
                        padding: '12px',
                        display: 'flex',
                        flexDirection: 'column'
                      }}>
                        <Table
                          components={components}
                          columns={mergedColumns}
                          dataSource={getPaginatedData(manualRespondedEforms, 'manualResponded')}
                          rowKey="id"
                          loading={loading}
                          pagination={false}
                          onRow={(record) => ({
                            onClick: (e) => {
// ????綜等?????鞊??謅??蝞???蹓?謅????怨?謒????萄謘?
if (e.target.closest('td.ant-table-cell-fix-left-last') || 
                                  e.target.closest('th.ant-table-cell-fix-left-last') ||
                                  e.target.closest('td.ant-table-cell-fix-left') ||
                                  e.target.closest('th.ant-table-cell-fix-left')) {
                                return;
                              }
                              handleViewEform(record);
                            },
                            style: getRowStyle(record)
                          })}
                          scroll={{ 
                            x: 1200,
                            y: getTableScrollHeight()
                          }}
                          sticky={{
                            offsetHeader: 0
                          }}
                          locale={{
                            emptyText: (
                              <Empty 
                                description={t('pendingTasks.noManualRespondedForms')} 
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                              />
                            )
                          }}
                        />
                        <div style={{ marginTop: 16, textAlign: 'left' }}>
                          <Pagination
                            current={paginationStates.manualResponded.current}
                            pageSize={paginationStates.manualResponded.pageSize}
                            total={counts.manualResponded}
                            showSizeChanger
                            showQuickJumper
                            pageSizeOptions={['10', '20', '50', '100']}
                            showTotal={(total, range) => 
                              t('pendingTasks.pageRange', { start: range[0], end: range[1], total })
                            }
                            onChange={handlePaginationChange('manualResponded')}
                            onShowSizeChange={handlePageSizeChange('manualResponded')}
                          />
                        </div>
                      </div>
                    )
                  }
                ] : [                  {
                    key: 'pending',
                    label: (
                      <Space>
                        <Text>{t('pendingTasks.pendingForms')}</Text>
                        <Badge count={counts.pending} showZero />
                      </Space>
                    ),
                    children: (
                      <div style={{ 
                        flex: 1, 
                        minHeight: 0, 
                        overflow: 'hidden',
                        padding: '12px',
                        display: 'flex',
                        flexDirection: 'column'
                      }}>
              <Table
                components={components}
                columns={mergedColumns}
                dataSource={getPaginatedData(pendingEforms, 'pending')}
                rowKey="id"
                loading={loading}
                pagination={false}
                expandable={{
                  expandedRowKeys: expandedRowKeys,
                  onExpandedRowsChange: setExpandedRowKeys,
                  expandedRowRender: renderExpandedRow,
                  expandRowByClick: false,
                  expandIconColumnIndex: 0,
                  expandIconColumnTitle: () => (
                    <Button
                      type="text"
                      size="small"
                      icon={(() => {
                        const currentEforms = getCurrentEforms();
                        const expandableKeys = currentEforms
                          .filter(hasExpandableContent)
                          .map(record => record.id);
                        
                        const allExpanded = expandableKeys.length > 0 && expandableKeys.every(key => expandedRowKeys.includes(key));
                        return allExpanded ? <MinusOutlined /> : <PlusOutlined />;
                      })()}
                      onClick={handleToggleExpandAll}
                      title="??賂豢???/???"
                      style={{ padding: '2px 6px', fontSize: '12px' }}
                    />
                  ),
                  expandIcon: ({ expanded, onExpand, record }) => {
                    if (!hasExpandableContent(record)) return null;
                    
                    return (
                      <Button
                        type="text"
                        size="small"
                        icon={expanded ? <MinusOutlined /> : <PlusOutlined />}
                        onClick={(e) => {
                          e.stopPropagation();
                          onExpand(record, e);
                        }}
                        style={{ 
                          width: '20px', 
                          height: '20px', 
                          padding: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      />
                    );
                  }
                }}
                onRow={(record) => ({
                  onClick: (e) => {
                    if (e.target.closest('td.ant-table-cell-fix-left-last') || 
                        e.target.closest('th.ant-table-cell-fix-left-last') ||
                        e.target.closest('td.ant-table-cell-fix-left') ||
                        e.target.closest('th.ant-table-cell-fix-left')) {
                      return;
                    }
                    handleViewEform(record);
                  },
                  style: getRowStyle(record)
                })}
                scroll={{ 
                  x: 1000,
                  y: getTableScrollHeight()
                }}
                sticky={{
                  offsetHeader: 0
                }}
                locale={{
                  emptyText: (
                    <Empty 
                      description={t('pendingTasks.noPendingTasks')} 
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                    />
                  )
                }}
              />
              <div style={{ marginTop: 16, textAlign: 'left' }}>
                <Pagination
                  current={paginationStates.pending.current}
                  pageSize={paginationStates.pending.pageSize}
                  total={counts.pending}
                  showSizeChanger
                  showQuickJumper
                  pageSizeOptions={['10', '20', '50', '100']}
                  showTotal={(total, range) => 
                    t('pendingTasks.pageRange', { start: range[0], end: range[1], total })
                  }
                  onChange={handlePaginationChange('pending')}
                  onShowSizeChange={handlePageSizeChange('pending')}
                />
              </div>
            </div>
                    )
                  },
                  {
                    key: 'approved',
                    label: (
                      <Space>
                        <Text>{t('pendingTasks.approvedForms')}</Text>
                        <Badge count={counts.approved} showZero />
                      </Space>
                    ),
                    children: (
                      <div style={{ 
                        flex: 1, 
                        minHeight: 0, 
                        overflow: 'hidden',
                        padding: '12px',
                        display: 'flex',
                        flexDirection: 'column'
                      }}>
                        <Table
                          components={components}
                          columns={mergedColumns}
                          dataSource={getPaginatedData(approvedEforms, 'approved')}
                          rowKey="id"
                          loading={loading}
                          pagination={false}
                          expandable={{
                            expandedRowKeys: expandedRowKeys,
                            onExpandedRowsChange: setExpandedRowKeys,
                            expandedRowRender: renderExpandedRow,
                            expandRowByClick: false,
                            expandIcon: ({ expanded, onExpand, record }) => {
                              if (!hasExpandableContent(record)) return null;
                              
                              return (
                                <Button
                                  type="text"
                                  size="small"
                                  icon={expanded ? <MinusOutlined /> : <PlusOutlined />}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onExpand(record, e);
                                  }}
                                  style={{ 
                                    width: '20px', 
                                    height: '20px', 
                                    padding: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}
                                />
                              );
                            }
                          }}
                          onRow={(record) => ({
                            onClick: (e) => {
                              if (e.target.closest('td.ant-table-cell-fix-left-last') || 
                                  e.target.closest('th.ant-table-cell-fix-left-last') ||
                                  e.target.closest('td.ant-table-cell-fix-left') ||
                                  e.target.closest('th.ant-table-cell-fix-left')) {
                                return;
                              }
                              handleViewEform(record);
                            },
                            style: getRowStyle(record)
                          })}
                          scroll={{ 
                            x: 1200,
                            y: getTableScrollHeight()
                          }}
                          sticky={{
                            offsetHeader: 0
                          }}
                          locale={{
                            emptyText: (
                              <Empty 
                                description={t('pendingTasks.noApprovedForms')} 
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                              />
                            )
                          }}
                        />
                        <div style={{ marginTop: 16, textAlign: 'left' }}>
                          <Pagination
                            current={paginationStates.approved.current}
                            pageSize={paginationStates.approved.pageSize}
                            total={counts.approved}
                            showSizeChanger
                            showQuickJumper
                            pageSizeOptions={['10', '20', '50', '100']}
                            showTotal={(total, range) => 
                              t('pendingTasks.pageRange', { start: range[0], end: range[1], total })
                            }
                            onChange={handlePaginationChange('approved')}
                            onShowSizeChange={handlePageSizeChange('approved')}
                          />
                        </div>
                      </div>
                    )
                  },
                  {
                    key: 'rejected',
                    label: (
                      <Space>
                        <Text>{t('pendingTasks.rejectedForms')}</Text>
                        <Badge count={counts.rejected} showZero />
                      </Space>
                    ),
                    children: (
                      <div style={{ 
                        flex: 1, 
                        minHeight: 0, 
                        overflow: 'hidden',
                        padding: '12px',
                        display: 'flex',
                        flexDirection: 'column'
                      }}>
                        <Table
                          components={components}
                          columns={mergedColumns}
                          dataSource={getPaginatedData(rejectedEforms, 'rejected')}
                          rowKey="id"
                          loading={loading}
                          pagination={false}
                          expandable={{
                            expandedRowKeys: expandedRowKeys,
                            onExpandedRowsChange: setExpandedRowKeys,
                            expandedRowRender: renderExpandedRow,
                            expandRowByClick: false,
                            expandIcon: ({ expanded, onExpand, record }) => {
                              // Form ?殉????PV ?２????????寞??????expand ?謘曉
                              if (!hasExpandableContent(record)) return null;
                              
                              return (
                                <Button
                                  type="text"
                                  size="small"
                                  icon={expanded ? <MinusOutlined /> : <PlusOutlined />}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onExpand(record, e);
                                  }}
                                  style={{ 
                                    width: '20px', 
                                    height: '20px', 
                                    padding: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}
                                />
                              );
                            }
                          }}
                          onRow={(record) => ({
                            onClick: (e) => {
// ????綜等?????鞊??謅??蝞???蹓?謅????怨?謒????萄謘?
if (e.target.closest('td.ant-table-cell-fix-left-last') || 
                                  e.target.closest('th.ant-table-cell-fix-left-last') ||
                                  e.target.closest('td.ant-table-cell-fix-left') ||
                                  e.target.closest('th.ant-table-cell-fix-left')) {
                                return;
                              }
                              handleViewEform(record);
                            },
                            style: getRowStyle(record)
                          })}
                          scroll={{ 
                            x: 1200,
                            y: getTableScrollHeight()
                          }}
                          sticky={{
                            offsetHeader: 0
                          }}
                          locale={{
                            emptyText: (
                              <Empty 
                                description={t('pendingTasks.noRejectedForms')} 
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                              />
                            )
                          }}
                        />
                        <div style={{ marginTop: 16, textAlign: 'left' }}>
                          <Pagination
                            current={paginationStates.rejected.current}
                            pageSize={paginationStates.rejected.pageSize}
                            total={counts.rejected}
                            showSizeChanger
                            showQuickJumper
                            pageSizeOptions={['10', '20', '50', '100']}
                            showTotal={(total, range) => 
                              t('pendingTasks.pageRange', { start: range[0], end: range[1], total })
                            }
                            onChange={handlePaginationChange('rejected')}
                            onShowSizeChange={handlePageSizeChange('rejected')}
                          />
                        </div>
                      </div>
                    )
                  }
                ]}
              />
          </Card>
          </div>
        </div>

        {/* Approval Confirmation Modal - zIndex ?朵謘?Embedded Form Modal (1050) */}
        <Modal
          title={getEFormApprovalLabels(selectedEform, t).approve}
          open={approveModalVisible}
          onOk={handleConfirmApprove}
          zIndex={1060}
          onCancel={() => setApproveModalVisible(false)}
          confirmLoading={processingEform === selectedEform?.id}
          okText={getEFormApprovalLabels(selectedEform, t).approve}
          cancelText={t('pendingTasks.cancel')}
          okButtonProps={{ 
            type: 'primary',
            style: { backgroundColor: '#52c41a', borderColor: '#52c41a' }
          }}
        >
          <Alert
            message={getEFormApprovalLabels(selectedEform, t).approve}
            description={`${getEFormApprovalLabels(selectedEform, t).approve}??{selectedEform?.instanceName || selectedEform?.formName || '-'}???`}
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
          />
          <div>
            <Text strong>{t('pendingTasks.applicantLabel')}</Text>
            <Text>{selectedEform?.createdBy}</Text>
          </div>
          <div style={{ marginTop: 8 }}>
            <Text strong>{t('pendingTasks.applicationTimeLabel')}</Text>
            <Text>{selectedEform?.createdAt ? TimezoneUtils.formatDateWithTimezone(selectedEform.createdAt, userTimezoneOffset) : '-'}</Text>
          </div>
          <Divider />
          <div>
            <Text strong>{t('pendingTasks.approvalNote')}</Text>
            <Input.TextArea
              value={approvalNote}
              onChange={(e) => setApprovalNote(e.target.value)}
              placeholder={t('pendingTasks.approvalNotePlaceholder')}
              rows={3}
              style={{ marginTop: 8 }}
            />
          </div>
        </Modal>

        {/* Rejection Confirmation Modal - zIndex ?朵謘?Embedded Form Modal (1050) */}
        <Modal
          title={getEFormApprovalLabels(selectedEform, t).reject}
          open={rejectModalVisible}
          onOk={handleConfirmReject}
          zIndex={1060}
          onCancel={() => setRejectModalVisible(false)}
          confirmLoading={processingEform === selectedEform?.id}
          okText={getEFormApprovalLabels(selectedEform, t).reject}
          cancelText={t('pendingTasks.cancel')}
          okButtonProps={{ 
            type: 'primary',
            danger: true
          }}
        >
          <Alert
            message={getEFormApprovalLabels(selectedEform, t).reject}
            description={`${getEFormApprovalLabels(selectedEform, t).reject}??{selectedEform?.instanceName || selectedEform?.formName || '-'}???`}
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}
          />
          <div>
            <Text strong>{t('pendingTasks.applicantLabel')}</Text>
            <Text>{selectedEform?.createdBy}</Text>
          </div>
          <div style={{ marginTop: 8 }}>
            <Text strong>{t('pendingTasks.applicationTimeLabel')}</Text>
            <Text>{selectedEform?.createdAt ? TimezoneUtils.formatDateWithTimezone(selectedEform.createdAt, userTimezoneOffset) : '-'}</Text>
          </div>
          <Divider />
          <div>
             <Text strong>{t('pendingTasks.rejectionReason')}</Text>
            <Input.TextArea
              value={approvalNote}
              onChange={(e) => setApprovalNote(e.target.value)}
              placeholder={t('pendingTasks.rejectionReasonPlaceholder')}
              rows={3}
              style={{ marginTop: 8 }}
              required
            />
          </div>
         </Modal>

         {/* Status Change Confirmation Modal - zIndex ?朵謘?Embedded Form Modal */}
         <Modal
           title={t('pendingTasks.statusChangeConfirmation')}
           open={statusChangeModalVisible}
           onOk={processStatusChange}
           zIndex={1060}
           onCancel={() => setStatusChangeModalVisible(false)}
           confirmLoading={processingEform === statusChangeTarget?.eform?.id}
           okText={t('pendingTasks.confirmStatusChange')}
           cancelText={t('pendingTasks.cancel')}
           okButtonProps={{ 
             type: 'primary',
             danger: statusChangeTarget?.newStatus === 'Rejected',
             style: statusChangeTarget?.newStatus === 'Approved' ? 
               { backgroundColor: '#52c41a', borderColor: '#52c41a' } : undefined
           }}
         >
           {statusChangeTarget && (
             <>
               <Alert
                 message={t('pendingTasks.statusChangeWarning')}
                 description={
                   <div>
                     <div style={{ marginBottom: 12 }}>
                       <Text strong>{t('pendingTasks.currentStatus')}: </Text>
                       <Tag color={statusChangeTarget.eform.status === 'Approved' ? 'green' : 'red'}>
                         {statusChangeTarget.eform.status === 'Approved'
                           ? getEFormApprovalLabels(statusChangeTarget.eform, t, { approve: 'pendingTasks.approved', reject: 'pendingTasks.rejected' }).approve
                           : getEFormApprovalLabels(statusChangeTarget.eform, t, { approve: 'pendingTasks.approved', reject: 'pendingTasks.rejected' }).reject}
                       </Tag>
                     </div>
                     <div style={{ marginBottom: 12 }}>
                       <Text strong>{t('pendingTasks.decidedBy')}: </Text>
                       <Text>{statusChangeTarget.eform.approvedBy || statusChangeTarget.eform.rejectedBy || '-'}</Text>
                     </div>
                     <div style={{ marginBottom: 12 }}>
                       <Text strong>{t('pendingTasks.decidedAt')}: </Text>
                       <Text>{statusChangeTarget.eform.approvalAt ? TimezoneUtils.formatDateWithTimezone(statusChangeTarget.eform.approvalAt, userTimezoneOffset) : 
                              statusChangeTarget.eform.rejectedAt ? TimezoneUtils.formatDateWithTimezone(statusChangeTarget.eform.rejectedAt, userTimezoneOffset) : '-'}</Text>
                     </div>
                     <div>
                       <Text strong>{t('pendingTasks.changeTo')}: </Text>
                       <Tag color={statusChangeTarget.newStatus === 'Approved' ? 'green' : 'red'}>
                         {statusChangeTarget.newStatus === 'Approved'
                           ? getEFormApprovalLabels(statusChangeTarget.eform, t, { approve: 'pendingTasks.approved', reject: 'pendingTasks.rejected' }).approve
                           : getEFormApprovalLabels(statusChangeTarget.eform, t, { approve: 'pendingTasks.approved', reject: 'pendingTasks.rejected' }).reject}
                       </Tag>
                     </div>
                   </div>
                 }
                 type="warning"
                 showIcon
                 style={{ marginBottom: 16 }}
               />
               <div style={{ marginTop: 16 }}>
                 <Text strong>{t('pendingTasks.confirmStatusChangeQuestion')}</Text>
               </div>
               <div style={{ marginTop: 16 }}>
                 <Text strong>{statusChangeTarget.newStatus === 'Approved' ? '?摮??謕?:' : '????謕?:'}</Text>
                 <Input.TextArea
                   value={statusChangeNote}
                   onChange={(e) => setStatusChangeNote(e.target.value)}
                   placeholder={statusChangeTarget.newStatus === 'Approved' ? '?ｇ???鈭歹?????..' : '?ｇ???鈭??荒????..'}
                   rows={3}
                   style={{ marginTop: 8 }}
                   maxLength={500}
                   showCount
                 />
               </div>
             </>
           )}
         </Modal>

         {/* Batch Processing Confirmation Modal */}
         <Modal
           title={t('pendingTasks.batchOperationConfirmation')}
           open={batchProcessingModalVisible}
           onOk={processBatchAction}
           onCancel={() => setBatchProcessingModalVisible(false)}
           confirmLoading={processingBatch}
           okText={t('pendingTasks.confirmExecute')}
           cancelText={t('pendingTasks.cancel')}
           okButtonProps={{ 
             type: 'primary',
             danger: batchAction === 'reject' || batchAction === 'changeToRejected',
             style: (batchAction === 'approve' || batchAction === 'changeToApproved') ? 
               { backgroundColor: '#52c41a', borderColor: '#52c41a' } : undefined
           }}
         >
           <Alert
             message={t('pendingTasks.batchOperationConfirmation')}
             description={
               <div>
                 <div style={{ marginBottom: 12 }}>
                   <Text strong>{t('pendingTasks.batchOperationType')}: </Text>
                   <Tag color={
                     batchAction === 'approve' || batchAction === 'changeToApproved' ? 'green' :
                     batchAction === 'reject' || batchAction === 'changeToRejected' ? 'red' : 'default'
                   }>
                     {batchAction === 'approve' ? t('pendingTasks.batchApprove') :
                      batchAction === 'reject' ? t('pendingTasks.batchReject') :
                      batchAction === 'changeToApproved' ? t('pendingTasks.batchChangeToApproved') :
                      batchAction === 'changeToRejected' ? t('pendingTasks.batchChangeToRejected') : batchAction}
                   </Tag>
                 </div>
                 <div style={{ marginBottom: 12 }}>
                   <Text strong>{t('pendingTasks.selectedFormsCount')}: </Text>
                    <Text>{selectedRows.length}</Text>
                 </div>
                 <div style={{ marginBottom: 12 }}>
                   <Text strong>{t('pendingTasks.formsList')}: </Text>
                   <div style={{ 
                     maxHeight: '120px', 
                     overflow: 'auto', 
                     border: '1px solid #d9d9d9', 
                     borderRadius: '4px',
                     padding: '8px',
                     backgroundColor: '#fafafa',
                     marginTop: '4px'
                   }}>
                     {selectedRows.map((row, index) => (
                       <div key={row.id} style={{ 
                         fontSize: '12px', 
                         marginBottom: '2px',
                         color: '#666'
                       }}>
                         {index + 1}. {row.formName}
                       </div>
                     ))}
                   </div>
                 </div>
                 <div>
                   <Text strong>{t('pendingTasks.confirmBatchOperation')}</Text>
                 </div>
               </div>
             }
             type="warning"
             showIcon
             style={{ marginBottom: 16 }}
           />
           <div style={{ marginTop: 16 }}>
             <Text strong>{t('pendingTasks.operationNote')}:</Text>
             <Input.TextArea
               value={batchNote}
               onChange={(e) => setBatchNote(e.target.value)}
               placeholder={t('pendingTasks.operationNotePlaceholder')}
               rows={3}
               style={{ marginTop: 8 }}
               maxLength={500}
               showCount
             />
           </div>
         </Modal>

         {/* Lightbox Modal */}
        <Modal
          title={lightboxFile ? lightboxFile.fileName : ''}
          open={lightboxVisible}
          onCancel={closeLightbox}
          footer={null}
          width="95%"
          style={{ top: 10 }}
          zIndex={2000}
          styles={{
            body: { 
              padding: 0, 
              height: '80vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#000'
            }
          }}
        >
          {lightboxFile && (
            <div style={{ 
              position: 'relative', 
              width: '100%', 
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {/* ?謚???? */}
              <Button
                type="text"
                icon={<CloseOutlined />}
                onClick={closeLightbox}
                style={{
                  position: 'absolute',
                  top: 10,
                  right: 10,
                  zIndex: 1000,
                  color: '#fff',
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  border: 'none'
                }}
              />
              
              {/* ???????*/}
              {lightboxFiles.length > 1 && (
                <Button
                  type="text"
                  icon={<LeftOutlined />}
                  onClick={goToPrevious}
                  style={{
                    position: 'absolute',
                    left: 10,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    zIndex: 1000,
                    color: '#fff',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    border: 'none'
                  }}
                />
              )}
              
              {/* ????????*/}
              {lightboxFiles.length > 1 && (
                <Button
                  type="text"
                  icon={<RightOutlined />}
                  onClick={goToNext}
                  style={{
                    position: 'absolute',
                    right: 10,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    zIndex: 1000,
                    color: '#fff',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    border: 'none'
                  }}
                />
              )}
              
              {/* ?謘?/?秋?赯湔? */}
              {getFileType(lightboxFile.fileName) === 'image' ? (
                <img
                  src={lightboxFile.filePath}
                  alt={lightboxFile.fileName}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain'
                  }}
                />
              ) : getFileType(lightboxFile.fileName) === 'video' ? (
                <video
                  src={lightboxFile.filePath}
                  controls
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%'
                  }}
                />
              ) : null}
              
              {/* ?謘??殷????*/}
              {lightboxFiles.length > 1 && (
                <div style={{
                  position: 'absolute',
                  bottom: 20,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  color: '#fff',
                  backgroundColor: 'rgba(0,0,0,0.7)',
                  padding: '8px 16px',
                  borderRadius: '20px',
                  fontSize: '14px'
                }}>
                  {lightboxCurrentIndex + 1} / {lightboxFiles.length}
                </div>
              )}
            </div>
          )}
        </Modal>

        {/* Embedded Form Instance Modal */}
        <Modal
          title={renderModalTitle()}
          open={embeddedFormVisible}
          onCancel={handleCloseEmbeddedForm}
          footer={[]}
          width="90%"
          style={{ top: 20 }}
          zIndex={1050}
          destroyOnHidden={true}
          maskClosable={false}
          className="embedded-form-modal"
          styles={{
            body: {
              padding: 0,
              overflowY: 'auto',
            }
          }}
        >
          {loadingEmbeddedForm ? (
            <div style={{ textAlign: 'center', padding: '50px' }}>
              <Spin size="large" />
              <div style={{ marginTop: '16px' }}>{t('pendingTasks.loadingFormInstance')}</div>
            </div>
          ) : embeddedFormInstance ? (
            <EFormViewerBody
              instance={embeddedFormInstance}
              relatedAttachments={relatedAttachments}
              loadingAttachments={loadingAttachments}
              userTimezoneOffset={userTimezoneOffset}
              processUserMessage={extractAiAnalysisResult}
              lightboxZIndex={2000}
              contentMinHeight={600}
              workflowInstanceId={embeddedFormInstance?.workflowInstanceId || embeddedFormInstance?.workflowExecutionId || null}
              workflowStepExecutionId={embeddedFormInstance?.workflowStepExecutionId || null}
              onAttachmentsUploaded={() => loadRelatedAttachments(embeddedFormInstance?.id)}
              formContentSlot={
                <div
                  ref={embeddedFormContainerRef}
                  style={{
                    minHeight: 'calc(100vh - 220px)',
                    padding: embedFormIframeSrc ? 0 : '16px',
                    overflow: embedFormIframeSrc ? 'hidden' : 'auto',
                    backgroundColor: embeddedFormInstance.fillType === 'Manual' ? '#ffffff' : '#fafafa',
                    display: embedFormIframeSrc ? 'flex' : 'block',
                    flexDirection: embedFormIframeSrc ? 'column' : undefined
                  }}
                >
                  <EFormContentViewer
                    fillType={embeddedFormInstance.fillType}
                    htmlCode={embeddedFormInstance.filledHtmlCode || embeddedFormInstance.htmlCode || ''}
                    fieldDisplaySettings={embeddedFormInstance.fieldDisplaySettings}
                    metaFlowJson={embeddedFormInstance.metaFlowJson}
                    fallback={
                      embedFormIframeSrc ? (
                        <iframe
                          ref={embedFormIframeRef}
                          src={embedFormIframeSrc}
                          title="Form Content"
                          onLoad={() => {
                            setEmbedFormIframeLoaded(n => n + 1);
                            const iframe = embedFormIframeRef.current;
                            const doc = iframe?.contentDocument;
                            const body = doc?.body;
                            if (doc) injectFlatpickrIntoIframe(doc);
                            if (body) applyFormEnhancements(body, undefined, { skipFlatpickr: true });
                          }}
                          style={{ width: '100%', height: 'calc(100vh - 220px)', border: 'none', display: 'block' }}
                        />
                      ) : (
                        <div
                          className="form-content-inner"
                          dangerouslySetInnerHTML={{
                            __html: embeddedFormInstance.filledHtmlCode || embeddedFormInstance.htmlCode || ''
                          }}
                        />
                      )
                    }
                  />
                </div>
              }
            />
          ) : (
            <div style={{ textAlign: 'center', padding: '50px' }}>
              <Empty description={t('pendingTasks.noFormData')} />
            </div>
          )}
        </Modal>
      </Content>
    </Layout>
  );
};

export default PendingTasksPage;
